import React, {useCallback, useContext, useEffect, useState} from 'react';
import { motion } from "framer-motion"; // Добавляем анимацию
import { observer } from 'mobx-react-lite';
import { Context } from '../../../index';
import {
    fetchGenre,
    fetchLanguages,
    fetchPrices,
    fetchAssTypes,
    fetchTypes,
    fetchCurrentUserAssigns,
    fetchAssignmentsCountForUser,
    createAssignment, getTargetingForecastApi, fetchAssignmentsForThisBook, getPriceAdvisorStatsApi,
} from '../../../http/bookAPI';
import Modal from 'react-bootstrap/Modal';
import {Alert, Button, Card, InputGroup, OverlayTrigger, Popover, Spinner} from 'react-bootstrap';
import {check, getRedirectUrlApi, updateUserVirtBalanceAssignmentCreateApi} from "../../../http/userAPI";
import DaysSwitcher from "./DaySwitcher";
import {FaDollarSign, FaStar} from "react-icons/fa";
import FileUpload from "../../FileUpload";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import { Form } from 'react-bootstrap';
import {ADD_FUNDS_TO_USD_BALANCE_ROUTE} from "../../../utils/consts";
import {useNavigate} from "react-router-dom";
import AssignUnderBookS4 from "../../bookspages/AssignUnderBookS4";
import ReviewOwnershipCheck from "../../assignmentpages/ReviewOwnershipCheck";
import SetStarsRatingGuide from "../../assignmentpages/SetStarsRatingGuide";
import AssignmentPriceAdvisor from "../../modals/assign/AssignmentPriceAdvisor";
import DownloadProgressModal from "../DownloadProgressModal";
import {downloadWithProgress} from "../../../helpers/downloadWithProgress";

const HelpPopover = ({title, children}) => (
    <OverlayTrigger
        trigger="click"
        placement="top"
        rootClose
        overlay={
            <Popover style={{maxWidth: "520px"}}>
                <style>{`
                    .vl-help-popover-body h5,
                    .vl-help-popover-body h6 {
                        display: none;
                    }
                    .vl-help-popover-body,
                    .vl-help-popover-body .small {
                        font-size: 0.875rem !important;
                    }
                    .vl-help-popover-body .mt-2,
                    .vl-help-popover-body .mt-3,
                    .vl-help-popover-body > div {
                        margin-top: 0 !important;
                    }
                    .vl-help-popover-body p,
                    .vl-help-popover-body span {
                        margin-top: 0 !important;
                    }
                    .vl-help-popover-body p:last-child {
                        margin-bottom: 0;
                    }
                `}</style>
                <Popover.Header as="h6">{title}</Popover.Header>
                <Popover.Body className="text-muted vl-help-popover-body">{children}</Popover.Body>
            </Popover>
        }
    >
        <button
            type="button"
            className="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center"
            style={{width: "24px", height: "24px", padding: 0, lineHeight: 1}}
            aria-label={`Show help: ${title}`}
        >
            ?
        </button>
    </OverlayTrigger>
);

const InfoTitle = ({children, helpTitle, helpContent, className = ""}) => (
    <div className={`d-inline-flex align-items-center gap-2 ${className}`}>
        <h6 className="mb-0 text-muted">{children}</h6>
        <HelpPopover title={helpTitle || children}>{helpContent}</HelpPopover>
    </div>
);


const CreateAssign = observer(({ show, handleClose, bookData, onBookDataUpdate, mode }) => {

    const { user } = useContext(Context);
    const { book } = useContext(Context);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [initialSelectedDays, setInitialSelectedDays] = useState(null);

    const [basePrice, setBasePrice] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [priceAddition, setPriceAddition] = useState(0);
    const [assTypeAddition, setAssTypeAddition] = useState(0);
    const [siteAddition, setSiteAddition] = useState(0);
    const [bookTypeDiscount, setBookTypeDiscount] = useState(0);
    const [assTypeDiscount, setAssTypeDiscount] = useState(0);
    const [priceTypeDiscount, setPriceTypeDiscount] = useState(0);

    const [selectedBookType, setSelectedBookType] = useState(null);
    const [availableAssignments, setAvailableAssignments] = useState([]);
    const [availablePrices, setAvailablePrices] = useState([]); // Список доступных цен
    const [hasManualPriceChoice, setHasManualPriceChoice] = useState(false);
    const [boostReviewMode, setBoostReviewMode] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [assignmentsForThisBook, setAssignmentsForThisBook] = useState([]);
    const [inputUrl, setInputUrl] = useState(null);

    const [promoStartDate, setPromoStartDate] = useState('');
    const [promoDays, setPromoDays] = useState(1);

    const [targetingForecast, setTargetingForecast] = useState({ ok: false });
    const [isForecastLoading, setIsForecastLoading] = useState(false);
    const [forecastError, setForecastError] = useState('');

    const [totalWords, setTotalWords] = useState(null);
    const [selectedDays, setSelectedDays] = useState(null);
    const [currency, setCurrency] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [promoCode, setPromoCode] = useState("");
    const [audibleSite, setAudibleSite] = useState({
        audible_country: '',
        selected_audible_site: '',
    });

    const [selectedCountry, setSelectedCountry] = useState("");
    const [bookCostCompensation, setBookCostCompensation] = useState(0);

    const [hoveredItemId, setHoveredItemId] = useState(null);
    const [hoveredItemIdPrice, setHoveredItemIdPrice] = useState(null);
    const [hoveredItem, setHoveredItem] = useState(null);

    // внутри CreateAssign (рядом с другими useState)
    const [priceStats, setPriceStats] = useState(null);
    const [isPriceStatsLoading, setIsPriceStatsLoading] = useState(false);
    const [priceStatsError, setPriceStatsError] = useState("");
    const [downloadModal, setDownloadModal] = useState({ show: false, progress: 0, status: "" });


    const [uploadedFileName, setUploadedFileName] = useState(null);
    const [fileHash, setFileHash] = useState("");
    const [assignmentHint, setAssignmentHint] = useState("");
    const [isUploading, setIsUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [speedUp, setSpeedUp] = useState(0);
    const [speedUpEffect, setSpeedUpEffect] = useState({id: 0, sum: 0, label: "No Speed-Up Visual Effect"});
    const [userCount, setUserCount] = useState(null);
    const [reviewQuality, setReviewQuality] = useState(0);

    const hasLocalFile = !!bookData?.book_download && bookData.book_download !== 'NO_MANUSCRIPT';

    const handlePreviewManuscriptDownload = async () => {
        if (!bookData?.id) return;
        setDownloadModal({
            show: true,
            progress: 0,
            status: "Preparing secure manuscript download...",
        });
        try {
            await downloadWithProgress({
                path: `api/book/${bookData.id}/manuscript-download`,
                filename: `${bookData?.title || "virtalibry-manuscript"}.pdf`,
                onProgress: (progress) => setDownloadModal((prev) => ({ ...prev, progress })),
                onStatus: (status) => setDownloadModal((prev) => ({ ...prev, status })),
            });
            setTimeout(() => setDownloadModal((prev) => ({ ...prev, show: false })), 700);
        } catch (error) {
            console.error("Manuscript preview download failed:", error);
            setDownloadModal((prev) => ({ ...prev, status: "Download failed. Please try again." }));
            toast.error("Failed to download manuscript. Please try again.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setTimeout(() => setDownloadModal((prev) => ({ ...prev, show: false })), 1400);
        }
    };

    const [searchQueryLink, setSearchQueryLink] = useState("");

    const [amzCountry, setAmzCountry] = useState({
      amz_country: '',
      selected_site: '',
    });

    const PRODUCT_ASSIGNMENT_IDS = [22, 23, 24, 25, 26, 27];
    const SET_STARS_ASSIGNMENT = {
        id: 32,
        ass_type_name: "Set Stars Rating",
        ass_type_todo: "Leave star rating",
        ass_price_shift: 0,
    };

    const amazonSites = [
        { code: "US", url: "https://www.amazon.com", label: "Amazon USA" },
        { code: "UK", url: "https://www.amazon.co.uk", label: "Amazon UK" },
        { code: "CA", url: "https://www.amazon.ca", label: "Amazon Canada" },
        { code: "DE", url: "https://www.amazon.de", label: "Amazon Germany" },
        { code: "FR", url: "https://www.amazon.fr", label: "Amazon France" },
        { code: "IT", url: "https://www.amazon.it", label: "Amazon Italy" },
        { code: "ES", url: "https://www.amazon.es", label: "Amazon Spain" },
        { code: "JP", url: "https://www.amazon.co.jp", label: "Amazon Japan" },
        { code: "AU", url: "https://www.amazon.com.au", label: "Amazon Australia" },
        { code: "IN", url: "https://www.amazon.in", label: "Amazon India" },
        { code: "MX", url: "https://www.amazon.com.mx", label: "Amazon Mexico" },
        { code: "BR", url: "https://www.amazon.com.br", label: "Amazon Brazil" },
    ];

    const reviewQualityList = [
        { code: "Flawless Legend", value: 100, label: "Flawless Legend — 100% only" },
        { code: "Diamond Standard", value: 98, label: "Diamond Standard — 98%+" },
        { code: "Elite Performer", value: 96, label: "Elite Performer — 96%+" },
        { code: "Gold Tier", value: 94, label: "Gold Tier — 94%+" },
        { code: "Pro Level", value: 92, label: "Pro Level — 92%+" },
        { code: "Trusted Pro", value: 90, label: "Trusted Pro — 90%+" },

        { code: "Solid & Steady", value: 85, label: "Solid & Steady — 85%+" },
        { code: "Reliable Choice", value: 80, label: "Reliable Choice — 80%+" },
        { code: "Getting There", value: 75, label: "Getting There — 75%+" },
        { code: "Minimum Acceptable", value: 70, label: "Minimum Acceptable — 70%+" },
    ];

    const speedUpMassive = [
        { id: 0, sum: 0, label: "No Speed-Up Bonus" },
        { id: 1, sum: 100, label: "+100 Virt Speed-Up" },
        { id: 2, sum: 200, label: "+200 Virt Speed-Up" },
        { id: 3, sum: 300, label: "+300 Virt Speed-Up" },
        { id: 4, sum: 500, label: "+500 Virt Speed-Up" },
        { id: 5, sum: 800, label: "+800 Virt Speed-Up" },
        { id: 6, sum: 1000, label: "+1000 Virt Speed-Up" },
        { id: 7, sum: 1500, label: "+1500 Virt Speed-Up" },
        { id: 8, sum: 2000, label: "+2000 Virt Speed-Up" },
        { id: 9, sum: 3000, label: "+3000 Virt Speed-Up" },
        { id: 10, sum: 4000, label: "+4000 Virt Speed-Up" },
        { id: 11, sum: 5000, label: "+5000 Virt Speed-Up" },
        { id: 12, sum: 7000, label: "+7000 Virt Speed-Up" },
    ];

    const speedUpEffectMassive = [
        { id: 0, sum: 0, label: "No Speed-Up Visual Effect (Beta Mode)" },
        { id: 1, sum: 100, label: "Bold Grey Frame +100 Virt (Beta Mode)" },
        { id: 2, sum: 150, label: "Bold Green Frame +150 Virt (Beta Mode)" },
        { id: 3, sum: 180, label: "Bold Gold Frame +180 Virt (Beta Mode)" },
        { id: 4, sum: 300, label: "Infinite Pulsation +300 Virt (Beta Mode)" },
        { id: 5, sum: 350, label: "Pulsation & Bold Grey Frame +350 Virt (Beta Mode)" },
        { id: 6, sum: 380, label: "Pulsation & Bold Green Frame +380 Virt (Beta Mode)" },
        { id: 7, sum: 400, label: "Pulsation & Bold Gold Frame +400 Virt (Beta Mode)" },
    ];

    const audibleSites = [
        { code: "AUS", url: "https://www.audible.com", label: "Audible USA" },
        { code: "AUK", url: "https://www.audible.co.uk", label: "Audible UK" },
       ];

// DB value examples:
// ["com","co.uk","fr","de","es","com.au","in","co.jp","ca","it"]
// or JSON string, or CSV string
    const parseMarketplacesValue = (v) => {
        // 1) получить массив строк
        let arr = [];
        if (!v) arr = [];
        else if (Array.isArray(v)) arr = v;
        else {
            const s = String(v).trim();
            if (!s) arr = [];
            else if (s.startsWith("[") && s.endsWith("]")) {
                try {
                    const parsed = JSON.parse(s);
                    arr = Array.isArray(parsed) ? parsed : [];
                } catch {
                    arr = s.split(/[,;|\n]+/g);
                }
            } else {
                arr = s.split(/[,;|\n]+/g);
            }
        }

        // 2) нормализовать домены к lower
        const domains = arr
            .map((x) => String(x).trim().toLowerCase())
            .filter(Boolean);

        // 3) домен -> country CODE (как в amazonSites.code)
        const domainToCode = (d) => {
            switch (d) {
                case "com": return "US";
                case "co.uk": return "UK";
                case "ca": return "CA";
                case "de": return "DE";
                case "fr": return "FR";
                case "it": return "IT";
                case "es": return "ES";
                case "co.jp": return "JP";
                case "com.au": return "AU";
                case "in": return "IN";
                case "com.mx": return "MX";
                case "com.br": return "BR";
                case "cn": return "CN";
                default: return ""; // неизвестное пропускаем
            }
        };

        // 4) вернуть уникальные codes
        return Array.from(
            new Set(domains.map(domainToCode).filter(Boolean))
        );
    };


// ✅ take marketplace key from amazonSites.url -> "com", "co.uk", "de", "co.jp", "com.au", ...
    const getMarketplaceKeyFromAmazonSiteUrl = (url) => {
        if (!url) return "";
        try {
            const host = new URL(url).hostname.toLowerCase(); // www.amazon.co.uk
            const i = host.lastIndexOf("amazon.");
            if (i === -1) return "";
            return host.slice(i + "amazon.".length); // "co.uk"
        } catch {
            return "";
        }
    };


    const bookTerritoriesModeRaw =
        book?.selectedCurrentUserBook?.territories_mode || "WORLDWIDE";
    const bookTerritoriesMode = String(bookTerritoriesModeRaw).toUpperCase(); // WORLDWIDE | MARKETPLACES

    const bookMarketplacesRaw =
        book?.selectedCurrentUserBook?.available_marketplaces || "";
    const bookAvailableMarketplaces = parseMarketplacesValue(bookMarketplacesRaw);

// null => no restriction (WORLDWIDE)
    const allowedMarketplaceCodes =
        bookTerritoriesMode === "WORLDWIDE"
            ? null
            : new Set(bookAvailableMarketplaces.map((x) => String(x).trim()).filter(Boolean));

    const allowedAmazonSites =
        !allowedMarketplaceCodes
            ? amazonSites
            : amazonSites.filter((s) => allowedMarketplaceCodes.has(s.code));



    useEffect(() => {
        if (!book?.selectedCurrentUserBook?.id) return; // ✅ Проверяем, существует ли ID книги

        const loadAssignments = async () => {

            try {
                const data = await fetchAssignmentsForThisBook(book.selectedCurrentUserBook.id);
                setAssignmentsForThisBook(data);
            } catch (error) {
                console.error("Error loading assignments:", error);
            } finally {

            }
        };

        loadAssignments();
    }, [book?.selectedCurrentUserBook?.id, assignmentsForThisBook.length]);

    const selectedAssign = assignmentsForThisBook.find(a => a.id === selectedId);

    const openRedirectedLink = async (link) => {
        if (!link) return;
        try {
            const { redirectUrl } = await getRedirectUrlApi(link);
            if (!redirectUrl) throw new Error("Redirect URL missing");
            window.open(redirectUrl, "_blank", "noopener,noreferrer");
        } catch (e) {
            console.error(e);
            toast.error("Could not open Amazon link safely. Please try again.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    // 🔁 Когда выбран marketplace и/или минимальное качество — тянем прогноз
    useEffect(() => {
        const userId = user?.user?.id;

        // Надёжно достаём выбранный marketplace из стейта (поддержим оба поля)
        const selectedMarketplace =
            amzCountry?.selected_site ??
            amzCountry?.amz_country ??
            '';

        const hasMarketplace = Boolean(selectedMarketplace);
        const rqNum = Number(reviewQuality) || 0;
        const hasQuality = rqNum > 0;

        // Если фильтры сняты — очищаем карточку
        if (!hasMarketplace && !hasQuality) {
            setTargetingForecast({ ok: false });
            setForecastError('');
            setIsForecastLoading(false);
            return;
        }

        // Если нет userId — тоже выходим тихо
        if (!userId) {
            setTargetingForecast({ ok: false });
            setForecastError('You must be logged in to see the forecast.');
            setIsForecastLoading(false);
            return;
        }

        let aborted = false;
        setIsForecastLoading(true);
        setForecastError('');

        (async () => {
            try {
                const data = await getTargetingForecastApi({
                    userId,
                    marketplace: hasMarketplace ? selectedMarketplace : null,
                    minQuality: hasQuality ? rqNum : 0, // не посылаем null
                });
                if (!aborted) setTargetingForecast(data ?? { ok: false });
            } catch (e) {
                if (!aborted) setForecastError('Failed to load forecast.');
            } finally {
                if (!aborted) setIsForecastLoading(false);
            }
        })();

        return () => {
            aborted = true;
        };
    }, [user?.user?.id, amzCountry?.selected_site, amzCountry?.amz_country, reviewQuality]);

// 🔁 Когда есть тип ассигмента и посчитана цена — тянем совет по цене
    useEffect(() => {
        if (!show) {
            setPriceStats(null);
            setPriceStatsError('');
            setIsPriceStatsLoading(false);
            setHasManualPriceChoice(false);
            return;
        }

        const assTypeId = Number(book?.selectedAssType?.id) || null;
        const booksPriceId = Number(book?.selectedPrice?.id) || null;

        // Итоговая цена
        const cur = Number(totalCost);
        const currentPriceVirt =
            Number.isFinite(cur) && cur > 0 ? Math.round(cur) : null;

        // Типы, где priceId обязателен
        const priceRequiredTypes = [3, 4, 5, 6, 32];
        const mustHavePriceId = priceRequiredTypes.includes(assTypeId);

        // Если отсутствует тип
        if (!assTypeId) {
            setPriceStats(null);
            setPriceStatsError('');
            setIsPriceStatsLoading(false);
            return;
        }

        // Если для типа обязателен priceId — но он не выбран
        if (mustHavePriceId && !booksPriceId) {
            setPriceStats(null);
            setPriceStatsError('');
            setIsPriceStatsLoading(false);
            return;
        }

        // Если нет рассчитанной цены
        if (currentPriceVirt == null) {
            setPriceStats(null);
            setPriceStatsError('');
            setIsPriceStatsLoading(false);
            return;
        }

        let aborted = false;
        setIsPriceStatsLoading(true);
        setPriceStatsError('');

        (async () => {
            try {
                const payload = {
                    assTypeId,
                    currentPriceVirt,
                };

                // Передаём priceId ТОЛЬКО если он обязателен
                if (mustHavePriceId) {
                    payload.booksPriceId = booksPriceId;
                }

                const data = await getPriceAdvisorStatsApi(payload);

                if (aborted) return;

                if (data?.ok) {
                    setPriceStats(data.stats || null);
                    setPriceStatsError('');
                } else {
                    setPriceStats(null);
                    setPriceStatsError(
                        data?.message || 'Failed to load price advisor stats.'
                    );
                }
            } catch (e) {
                if (!aborted) {
                    console.error('priceAdvisor error:', e);
                    setPriceStats(null);
                    setPriceStatsError('Failed to load price advisor stats.');
                }
            } finally {
                if (!aborted) {
                    setIsPriceStatsLoading(false);
                }
            }
        })();

        return () => {
            aborted = true;
        };
    }, [
        show,
        book?.selectedAssType?.id,
        book?.selectedPrice?.id,
        totalCost,
    ]);


    useEffect(() => {
        if (!show || !user?.user?.id) return;
        setLoading(true);

        const loadStats = async () => {
            try {
                const data = await fetchAssignmentsCountForUser(user?.user?.id);
                setUserCount(data);
                if (mode === 'book') {
                    setBasePrice(bookData?.default_price)
                } else {
                    setBasePrice(100)
                }

            } catch (error) {
                console.error("Error loading Count", error);
            } finally {
                setLoading(false);
                setBookCostCompensation (null);
            }
        };

        if (user?.user?.id) {
            loadStats();
        }


    }, [show, user?.user?.id]); // ✅ Запускаем проверку при изменении `show` или `user.id`

    const handlePromoCodeChange = (e) => {
        const normalizedValue = e.target.value.trim().toUpperCase();
        setPromoCode(normalizedValue);
    };

    const handleAudioSiteChange = (e) => {
        setSelectedCountry(e.target.value); // Сохраняем код страны
    };
    const handleSiteChange = (e) => {
        const newSite = e.target.value; // url or ""

        // if user tries to select marketplace not allowed for this book -> block + toast
        if (newSite && allowedMarketplaceCodes) {
            const picked = amazonSites.find((s) => s.url === newSite);
            if (picked && !allowedMarketplaceCodes.has(picked.code)) {
                toast.info(
                    `This book is not available on Amazon.${picked.code}. Please edit the book territories first.`,
                    { position: "bottom-center", autoClose: 3000, hideProgressBar: false }
                );
                return;
            }
        }

        setAmzCountry({
            amz_country: newSite,
            selected_site: newSite
        });

        setAudibleSite({
            audible_country: newSite,
            selected_audible_site: newSite
        });

        if (newSite === "") {
            setSiteAddition(0);
        }
    };


    const handleRQChange = (e) => {
        const val = Number(e?.target?.value ?? 0);
        setReviewQuality(Number.isFinite(val) ? val : 0);
    };

    const handleSpeedUpChange = (e) => {
        const selectedSpeedUp = Number(e.target.value);
        const speedUpItem = speedUpMassive.find(item =>
            item.sum === selectedSpeedUp || item.id === selectedSpeedUp
        );

        if (speedUpItem) {
            setSpeedUp(speedUpItem.sum);
        } else if (Number.isFinite(selectedSpeedUp)) {
            setSpeedUp(selectedSpeedUp);
        }
    }
    const handleSpeedUpEffectChange = (e) => {
        const selectedSpeedUpEffect = e.target.value;
        // Устанавливаем доплату в зависимости от выбранного Speed Up
        if (selectedSpeedUpEffect === 0) {
            setSpeedUpEffect({id: 0, sum: 0, label: "No Speed-Up Visual Effect"});
        } else {
            const speedUpEffectItem = speedUpEffectMassive.find(item => item.id === Number(selectedSpeedUpEffect));
            if (speedUpEffectItem) {
                setSpeedUpEffect(speedUpEffectItem);
            }
        }
    }

    useEffect(() => {
        if (amzCountry.selected_site === "") {
            setSiteAddition(0);
        } else {
            // Устанавливаем доплату по тарифу
            if (user.user.tariff_plan === "FREE") {
                setSiteAddition(200);
            } else if (user.user.tariff_plan === "ESSENTIAL") {
                setSiteAddition(100);
            } else if (user.user.tariff_plan === "PREMIUM") {
                setSiteAddition(0);
            }
        }
    }, [amzCountry.selected_site]);

    useEffect(() => {
        if (book.selectedAssType && (book.selectedAssType?.id === 4 || book.selectedAssType?.id === 6)) {
            setIsLoading(true);
            setTimeout(() => setIsLoading(false), 800); // ⚡ Имитация загрузки (0.8 сек)
        }
    }, [book.selectedAssType]); // 🔹 Перезапуск при выборе ассигнмента

    const [bookForAssignment, setBookForAssignment] = useState({
        paper_back_flag: bookData?.paper_back_flag || false,
        kindle_flag: bookData?.kindle_flag || false,
        kindle_unlimited_flag: bookData?.kindle_unlimited_flag || false,
        hard_cover_flag: bookData?.hard_cover_flag || false,
        audio_flag: bookData?.audio_flag || false,
    });

    const handleSearchQueryChange = (e) => {
        const normalizedValue = e.target.value.normalize("NFC").toLowerCase();
        setSearchQuery(normalizedValue);

        const formattedQuery = encodeURIComponent(normalizedValue.trim());

        const isPaperOrHard =
            selectedBookType?.key === "paper_back_flag" ||
            selectedBookType?.key === "hard_cover_flag";

        let amazonSearchURL;

        if (bookData?.book_type === "product") {
            // 🔍 Для продуктов — поиск по всей Amazon (All Departments)
            amazonSearchURL = `https://www.amazon.com/s?k=${formattedQuery}`;
        } else if (isPaperOrHard) {
            // 📘 Бумажная или твёрдая обложка → категория Books
            amazonSearchURL = `https://www.amazon.com/s?k=${formattedQuery}&i=stripbooks`;
        } else {
            // 📱 Электронная книга (Kindle)
            amazonSearchURL = `https://www.amazon.com/s?k=${formattedQuery}&i=digital-text&rh=n%3A133140011%2Cp_n_feature_browse-bin%3A618073011`;
        }

        setSearchQueryLink(amazonSearchURL);
    };



    const assignmentHints = {
        "Universal": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Universal" assignment type involve?</h6>
                    <span>
          The reader will download the book from Virtalibry, read it, and leave a review on Amazon.
                        {hasLocalFile ? (
                            <>
                                {" "}
                                Here is the download link your readers will receive:{" "}
                                <a
                                    href="#download-manuscript"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        handlePreviewManuscriptDownload();
                                    }}
                                    className="text-decoration-none fw-bold text-primary"
                                >
                                    📥 Download File
                                </a>
                            </>
                        ) : (
                            " Local file is not provided for this book."
                        )}
        </span>
                </div>
            </>
        ),
        "Kindle Unlimited": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Kindle Unlimited" assignment type involve?</h6>
                    <span>
                        The reader will access and read your book through Kindle Unlimited.
                        Once they finish, they will leave a insightful review on Amazon to help other
                        potential readers.
                        Since Kindle Unlimited books are borrowed rather than purchased, <strong>Amazon will not label this
                        review as a Verified Purchase.</strong>
                    </span>
                </div>

            </>
        ),
        "Verified Kindle Unlimited": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Verified Kindle Unlimited" assignment type involve?</h6>
                <span>
            This assignment requires an <strong>active paid Kindle Unlimited subscription</strong> (free trials don’t qualify).
            The reader must borrow the book via Kindle Unlimited and <strong>read it to the end until the “Read” badge appears</strong> in the Kindle reader.
            After that, the reader leaves a review on Amazon. In this scenario, the review is expected to receive the
            <strong> Verified Purchase</strong> label, which strengthens your book’s credibility.
        </span>
            </div>
        ),
        "Paperback BuyOut": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Paperback BuyOut" assignment type involve?</h6>
                <span>
            The reader will purchase your paperback book directly from Amazon, but <strong>no review will be left</strong>.
            This assignment is designed as a buy-out only, without feedback on the product page.
            You should note that this task involves <strong>additional expenses equal to the full retail price of your paperback</strong>,
            which will be charged in USD from your main account balance.
            After the purchase, the reviewer must provide <strong>proof of order</strong>.
            Once the proof is verified, the reviewer will receive their <strong>full retail price compensation</strong> and <strong>earned Virt post-paid</strong>.
        </span>
            </div>
        ),

        "Paperback Search&BuyOut": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Paperback Search&BuyOut" assignment type involve?</h6>
                <span>
      The reader will first <strong>search for your paperback book on Amazon</strong> using the keyword(s) you provide,
      then <strong>purchase it directly from the search results</strong> — not via a direct product link.
      This assignment does <strong>not require leaving a review</strong> and functions purely as a buy-out.
      You will be charged the <strong>full retail price of the book</strong> in USD from your main account balance.
      After the purchase, the reviewer must provide <strong>proof of order</strong> such as an order ID or confirmation screenshot.
      Once the proof is verified by our team, the reviewer will receive their <strong>full retail price compensation</strong> and <strong>earned Virt post-paid</strong>.
      This task helps improve your book’s visibility in <strong>organic Amazon search results</strong> while maintaining realistic buyer behavior.
    </span>
            </div>
        ),

        "Paperback Verified Purchase": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">
                    What does "Paperback Verified Purchase" assignment type involve?
                </h6>
                <span>
      The reader will <strong>purchase your paperback book directly from Amazon</strong>,
      provide <strong>proof of purchase</strong> such as an order confirmation or receipt,
      and then <strong>publish a review marked as Verified Purchase</strong>.
      This type of assignment combines a genuine sale with authentic feedback visible on the product page.
      You will be charged the <strong>full retail price of the book</strong> in USD from your main balance.
      After the proof is validated and the review is successfully published,
      the reviewer will receive their <strong>full retail price compensation</strong> together with <strong>earned Virt post-paid</strong>.
      This process ensures both a legitimate purchase record and a verified review,
      enhancing your book’s trust and visibility on Amazon.
    </span>
            </div>
        ),

        "Paperback VP Search&Buy": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">
                    What does "Paperback Verified Purchase Search&Buy" assignment type involve?
                </h6>
                <span>
      The reader will <strong>search for your paperback book on Amazon</strong> using the
      keyword(s) you provide, <strong>find it organically in search results</strong>, and
      <strong>purchase it directly from the listing</strong> — without using a direct product link.
      After completing the purchase, the reader must <strong>provide proof of order</strong>
      such as an order ID or confirmation screenshot, and then <strong>leave a review marked
      as Verified Purchase</strong>.
      You will be charged the <strong>full retail price of the book</strong> in USD from your
      main account balance.
      Once the proof is confirmed and the review is published, the reviewer will receive
      their <strong>full retail price compensation</strong> along with <strong>earned Virt
      post-paid</strong>.
      This assignment not only produces a genuine verified review but also improves your
      book’s <strong>organic visibility in Amazon search results</strong>.
    </span>
            </div>
        ),



        "Paperback Verified Purchase + Img": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Paperback Verified Purchase + Img" assignment type involve?</h6>
                <span>
            The reader will purchase your paperback book from Amazon and leave a <strong>Verified Purchase review</strong>
            that includes an <strong>image of the physical book</strong>.
            In this case, no additional proof of purchase is required, since the uploaded photo itself
            serves as proof that the paperback was received.
            You will be charged the <strong>full paperback cost</strong> in USD from your main balance.
            Once the review with image is published, the reviewer will receive their <strong>full retail price compensation</strong> and <strong>earned Virt post-paid</strong>.
        </span>
            </div>
        ),

        "Paperback Verified Purchase + Video": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Paperback Verified Purchase + Video" assignment type involve?</h6>
                <span>
            The reader will purchase your paperback book from Amazon and leave a <strong>Verified Purchase review</strong>
            that includes a <strong>video showcasing the physical book</strong>.
            The video serves as both proof of purchase and engaging content for potential buyers.
            You will be charged the <strong>full retail price of the paperback</strong> in USD from your main balance.
            Once the video review is published on Amazon, the reviewer will receive their <strong>full retail price compensation</strong> and <strong>earned Virt post-paid</strong>.
        </span>
            </div>
        ),
        "Hardcover BuyOut": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Hardcover BuyOut" assignment type involve?</h6>
                <span>
            The reader will purchase your Hardcover book directly from Amazon, but <strong>no review will be left</strong>.
            This assignment is designed as a buy-out only, without feedback on the product page.
            You should note that this task involves <strong>additional expenses equal to the full retail price of your Hardcover</strong>,
            which will be charged in USD from your main account balance.
            After the purchase, the reviewer must provide <strong>proof of order</strong>.
            Once the proof is verified, the reviewer will receive their <strong>full retail price compensation</strong> and <strong>earned Virt post-paid</strong>.
        </span>
            </div>
        ),

        "Hardcover Search&BuyOut": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Hardcover Search&BuyOut" assignment type involve?</h6>
                <span>
      The reader will first <strong>search for your Hardcover book on Amazon</strong> using the keyword(s) you provide,
      then <strong>purchase it directly from the search results</strong> — not via a direct product link.
      This assignment does <strong>not require leaving a review</strong> and functions purely as a buy-out.
      You will be charged the <strong>full retail price of the book</strong> in USD from your main account balance.
      After the purchase, the reviewer must provide <strong>proof of order</strong> such as an order ID or confirmation screenshot.
      Once the proof is verified by our team, the reviewer will receive their <strong>full retail price compensation</strong> and <strong>earned Virt post-paid</strong>.</span>
            </div>
        ),

        "Hardcover Verified Purchase": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">
                    What does "Hardcover Verified Purchase" assignment type involve?
                </h6>
                <span>
      The reader will <strong>purchase your Hardcover book directly from Amazon</strong>,
      provide <strong>proof of purchase</strong> such as an order confirmation or receipt,
      and then <strong>publish a review marked as Verified Purchase</strong>.
      This type of assignment combines a genuine sale with authentic feedback visible on the product page.
      You will be charged the <strong>full retail price of the book</strong> in USD from your main balance.
      After the proof is validated and the review is successfully published,
      the reviewer will receive their <strong>full retail price compensation</strong> together with <strong>earned Virt post-paid</strong>.
      This process ensures both a legitimate purchase record and a verified review,
      enhancing your book’s trust and visibility on Amazon.
    </span>
            </div>
        ),

        "Hardcover VP Search&Buy": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">
                    What does "Hardcover Verified Purchase Search&Buy" assignment type involve?
                </h6>
                <span>
      The reader will <strong>search for your Hardcover book on Amazon</strong> using the
      keyword(s) you provide, <strong>find it organically in search results</strong>, and
      <strong>purchase it directly from the listing</strong> — without using a direct product link.
      After completing the purchase, the reader must <strong>provide proof of order</strong>
      such as an order ID or confirmation screenshot, and then <strong>leave a review marked
      as Verified Purchase</strong>.
      You will be charged the <strong>full retail price of the book</strong> in USD from your
      main account balance.
      Once the proof is confirmed and the review is published, the reviewer will receive
      their <strong>full retail price compensation</strong> along with <strong>earned Virt
      post-paid</strong>.
      This assignment not only produces a genuine verified review but also improves your
      book’s <strong>organic visibility in Amazon search results</strong>.
    </span>
            </div>
        ),

        "Hardcover Verified Purchase + Img": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Hardcover Verified Purchase + Img" assignment type involve?</h6>
                <span>
            The reader will purchase your Hardcover and leave a <strong>Verified Purchase review</strong> that includes an
            <strong> image of the physical book</strong>.
            No additional proof is required, since the uploaded photo serves as proof of receipt.
            You are responsible for the <strong>full Hardcover price</strong>, charged in USD from your main balance.
            Once the image review is published, the reviewer will receive their <strong>full retail price compensation</strong> and
            <strong> earned Virt post-paid</strong>.
        </span>
            </div>
        ),

        "Hardcover Verified Purchase + Video": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Hardcover Verified Purchase + Video" assignment type involve?</h6>
                <span>
            The reader will purchase your hardcover and post a <strong>Verified Purchase review</strong> with a
            <strong> video showcasing the physical book</strong>.
            The video acts as proof and provides highly persuasive content for shoppers.
            You will be charged the <strong>full retail price</strong> in USD from your main balance.
            After the video review is live on Amazon, the reviewer will receive their <strong>full retail price compensation</strong> and
            <strong> earned Virt post-paid</strong>.
        </span>
            </div>
        ),

        "Verified Purchase": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Verified Purchase" assignment type involve?</h6>
                    <span>
                        The reader will buy your book directly from Amazon.
                        After reading the book, the reader will leave a short and honest review to let others know if they should check it out.
                        Upon completion of this assignment, you will receive a review <strong>stamped as Verified Purchase.</strong>
                    </span>
                </div>

            </>
        ),
        "Set Stars Rating": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Set Stars Rating" assignment type involve?</h6>
                    <span>
                        The reader must get the <strong>Kindle edition</strong> through Amazon, open it in a Kindle reader
                        or mobile Kindle app, and set a star rating there. This assignment does <strong>not</strong> require
                        a written review. If Amazon opens the review form after the stars are selected, the reviewer should
                        click <strong>No, Thank You</strong>, not <strong>Submit</strong>. The reviewer will submit a screenshot
                        proof from the Kindle reader/app showing the completed rating and the reviewer name/account visible
                        for staff verification.
                    </span>
                    <SetStarsRatingGuide />
                </div>
            </>
        ),

        "Verified Purchase + Img": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Verified Purchase + Img" assignment type involve?</h6>
                    <span>
                        The reader will purchase your book directly from Amazon.
                        After reading, the reader will write a brief and honest review to help others decide if the book is worth reading.<strong> You can provide book-related images</strong> for the reader to include in their review, enhancing its visual appeal and engagement.
                        Upon completion of this assignment, you will receive a review <strong>stamped as Verified Purchase.</strong>
                    </span>

                </div>
            </>


        ),
        "VP Search&Buy": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Verified Purchase Search&Buy" assignment type involve?</h6>
                    <span>
                        The reader will purchase your book directly from Amazon. You can ask the reader to find your
                        book using a <strong>specific
                        search query</strong> before making a purchase. This helps improve your book's visibility in
                        search results.
                        A single search query can be assigned per assignment. After reading, the reader will write a brief and honest review to help others decide if the book
                        is worth reading.
                        Upon completion of this assignment, you will receive a review <strong>stamped as Verified
                        Purchase.</strong>
                    </span>

                </div>

            </>


        ),
        "VP Search&Buy + Img": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Verified Purchase Search&Buy + Img" assignment type involve?</h6>
                    <span>
                        The reader will purchase your book directly from Amazon. You can ask the reader to find your
                        book using a <strong>specific
                        search query</strong> before making a purchase. This helps improve your book's visibility in
                        search results.
                        A single search query can be assigned per assignment. <strong>You can provide book-related
                        images</strong> for the reader to include in their review, enhancing its visual appeal and
                        engagement. After reading, the reader will write a brief and honest review to help others decide if the book
                        is worth reading.
                        Upon completion of this assignment, you will receive a review <strong>stamped as Verified
                        Purchase.</strong>
                    </span>


                </div>
            </>

        ),
        "Amazon Universal": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Amazon Universal for Audio" assignment type involve?</h6>
                    <span>
                        Amazon Universal means that your listener will download the audio file you provide,
                        listen to it, and leave an honest review on Audible. This assignment type is available because you
                        have specified that your book has Non-Exclusive Distribution, allowing you to distribute it through
                        channels other than Amazon and Audible.
                    </span>


                </div>
            </>

        ),
        "Audible Promo Code": (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Audible Promo Code" assignment type involve?</h6>
                    <span>
                        Audible Promo Code means that your listener will use the provided promo code,
                        listen to the audiobook, and leave an honest review on Audible.
                        You must specify the country for which the promo code was issued and enter the promo code itself.
                    </span>
                    <span>
                        This assignment type is available because you have indicated that your book has Exclusive Distribution,
                        meaning it can only be distributed through Amazon and Audible.
                        However, you are allowed to share promo codes with friends, family, and even strangers.
                    </span>
<p>
    If you do not have promo codes for your audiobook, you can request them from Audible or Amazon support.
    You may receive up to 50 promo codes in total—25 for the US and 25 for the UK.
    This assignment type allows you to take advantage of this opportunity.

</p>

                </div>
            </>

        ),
        "Audio ED + Img": (
            <>
                <div className="d-flex flex-column gap-2 small text-muted mt-2">
                    <h5 className="mt-2">What does this assignment type involve?</h5>
                  <div>
                    <p>
                        Audio Exclusive Distribution + Image means that your listener will use the provided promo code,
                        listen to the audiobook, and leave an honest review on Audible.
                        Additionally, you can upload a custom image of your book, which the
                        listener will include in their review to enhance its visual appeal.

                        You must specify the country for which the promo code was issued and enter the promo code itself.
                        This assignment type is available because you have indicated that your book has Exclusive Distribution,
                        meaning it can only be distributed through Amazon and Audible.
                        However, you are allowed to share promo codes with friends, family, and even strangers.
                    </p>
                    <p>
                        If you do not have promo codes for your audiobook, you can request them from Audible or Amazon support.
                        You may receive up to 50 promo codes in total—25 for the US and 25 for the UK.
                        This assignment type allows you to take advantage of this opportunity while also providing a unique image
                        for the listener’s review.
                    </p>
                  </div>

                </div>
            </>

        ),
        "Product BuyOut": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Product BuyOut" assignment type involve?</h6>
                <span>
      The participant will <strong>purchase your product directly from Amazon</strong>, but <strong>no review will be posted</strong>.
      This assignment serves purely as a buy-out to create a real sale record for your listing.
      You will be charged the <strong>full retail price</strong> of the item in USD from your main account balance.
      After completing the purchase, the participant must <strong>upload proof of order</strong> such as an order ID or screenshot.
      Once the proof is verified, the participant receives <strong>full retail compensation</strong> and their <strong>earned Virt post-paid</strong>.
    </span>
            </div>
        ),
        "Product Search&BuyOut": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Product Search & BuyOut" assignment type involve?</h6>
                <span>
      The participant will <strong>search for your product on Amazon</strong> using the keyword(s) you provide
      and then <strong>purchase it directly from the search results</strong> instead of a direct link.
      This type does <strong>not include leaving a review</strong> — it focuses solely on generating an authentic sale.
      The full product price in USD will be charged from your main balance.
      After proof of order is submitted and verified, the participant will receive <strong>full retail compensation</strong> plus their <strong>earned Virt post-paid</strong>.
    </span>
            </div>
        ),
        "Product Verified Purchase": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Product Verified Purchase" assignment type involve?</h6>
                <span>
      The participant will <strong>purchase your product on Amazon</strong>,
      submit <strong>proof of purchase</strong> (order confirmation or receipt),
      and then <strong>post a Verified Purchase review</strong>.
      This combines a real sale with authentic feedback visible on the product page.
      You will be charged the <strong>full retail price</strong> in USD from your main balance.
      Once the proof and review are confirmed, the participant receives <strong>full retail compensation</strong> together with <strong>earned Virt post-paid</strong>.
      This assignment increases trust and improves your product’s credibility on Amazon.
    </span>
            </div>
        ),
        "Product VP Search&Buy": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Product Verified Purchase Search & Buy" assignment type involve?</h6>
                <span>
      The participant will <strong>search for your product on Amazon</strong> using your keyword(s), <strong>find it organically in search results</strong>, and <strong>purchase it directly from the listing</strong>.
      After purchase, they must provide <strong>proof of order</strong> and then <strong>leave a Verified Purchase review</strong>.
      The full product price will be charged in USD from your balance.
      After validation and review publication, the participant receives <strong>full retail compensation</strong> and <strong>earned Virt post-paid</strong>.
      This task boosts both <strong>organic visibility</strong> and <strong>verified reviews</strong> for your product.
    </span>
            </div>
        ),
        "Product Verified Purchase + Img": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Product Verified Purchase + Image" assignment type involve?</h6>
                <span>
        The participant will purchase your product and post a <strong>Verified Purchase review</strong> that includes <strong>at least three images</strong> of the received item.
      The photo itself acts as proof of receipt, so no additional verification is required.
      You will be charged the <strong>full product price</strong> in USD from your main balance.
      Once the image review is published, the participant receives <strong>full retail compensation</strong> plus their <strong>earned Virt post-paid</strong>.
    </span>
            </div>
        ),
        "Product Verified Purchase + Video": (
            <div className="d-flex flex-column small text-muted mt-2">
                <h6 className="mb-1 mt-2 text-muted">What does "Product Verified Purchase + Video" assignment type involve?</h6>
                <span>
      The participant will purchase your product and post a <strong>Verified Purchase review</strong> featuring a <strong>video of the item in use or unboxing</strong>.
      The video serves as both proof of purchase and engaging visual content for potential buyers.
      You will be charged the <strong>full retail price</strong> in USD from your balance.
      Once the video review is live and verified, the participant receives <strong>full retail compensation</strong> along with their <strong>earned Virt post-paid</strong>.
    </span>
            </div>
        ),




    };

    const priceMatrix = {
        "Verified Purchase": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // Доступные цены для Review
        "Verified Purchase + Img": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // Доступные цены для VP Review
        "VP Search&Buy": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        "VP Search&Buy + Img": [2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        "Set Stars Rating": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    };

    useEffect(() => {
        if (book.selectedAssType) {
            const assignmentName = book.selectedAssType.ass_type_name;
            const allowedPriceIds = priceMatrix[assignmentName] || [];
            const filteredPrices = book.prices.filter(price => allowedPriceIds.includes(price.id));
            setAssignmentHint(assignmentHints[assignmentName] || "");
            setAvailablePrices(filteredPrices);
            // Если текущий выбранный price больше не доступен, сбрасываем
            if (!filteredPrices.some(price => price.id === book.selectedPrice?.id)) {
                book.setSelectedPrice(null);
            }
        }
    }, [book.selectedAssType, book.prices]); // Запускаем при изменении типа задания или списка цен

    const assignmentMatrix = {
        "kindle_flag": [
            ...(bookData?.kindle_unlimited_flag ? ["Kindle Unlimited", "Verified Kindle Unlimited"] : []),
            "Verified Purchase",
            "Verified Purchase + Img",
            "VP Search&Buy",
            "VP Search&Buy + Img",
            "Set Stars Rating"
        ],
        "paper_back_flag": ["Paperback Verified Purchase + Img", "Paperback Verified Purchase + Video",
     "Paperback BuyOut", "Paperback Search&BuyOut", "Paperback Verified Purchase", "Paperback VP Search&Buy",
        ],
        "hard_cover_flag": ["Hardcover Verified Purchase + Img", "Hardcover Verified Purchase + Video",
    "Hardcover BuyOut", "Hardcover Search&BuyOut", "Hardcover Verified Purchase", "Hardcover VP Search&Buy",
        ],
        "audio_flag": [
            ...(bookData?.audio_non_exclusive_flag ? ["Amazon Universal"] : []), "Audible Promo Code"]
    };

    const availableBookTypes = book.types
        .filter(type => bookForAssignment.hasOwnProperty(type.type) && bookForAssignment[type.type]).map(type => ({
            key: type.type, // ✅ Название ключа, например, "kindle_flag"
            label: type.type_name, // ✅ Отображаемое имя (например, "Kindle")
            id: type.id, // ✅ ID из базы
            type_todo: type.type_todo, // ✅ Дополнительное описание задачи для книги
            price_addition: type.book_type_price_addition, // ✅ Доп. цена формата
            price_shift: type.book_type_price_shift, // ✅ Сдвиг цены
            // ✅ Промо-скидка
            promotion_discount: type.book_type_promotion_price_discount, // Сумма скидки
            promotion_discount_start: type.book_type_promotion_price_discount_start_date, // Дата старта скидки
            promotion_discount_end: type.book_type_promotion_price_discount_end_date, // Дата окончания скидки

            // ✅ Промо-бонус
            promotion_bonus: type.book_type_promotion_price_bonus, // Сумма бонуса
            promotion_bonus_start: type.book_type_promotion_price_bonus_start_date, // Дата старта бонуса
            promotion_bonus_end: type.book_type_promotion_price_bonus_end_date, // Дата окончания бонуса

        }));
    const bookTypeOrder = ["kindle_flag", "paper_back_flag", "hard_cover_flag", "audio_flag"];

// Сначала определяем типы для продукта
    const productTypes = [
        { id: 7, key: "type1", label: "Type 1", flag: "kindle_flag" },
        { id: 8, key: "type2", label: "Type 2", flag: "paper_back_flag" },
        { id: 9, key: "type3", label: "Type 3", flag: "hard_cover_flag" },
        { id: 10, key: "type4", label: "Type 4", flag: "audio_flag" },
    ];

// Выбираем только те типы, для которых есть активные флаги у продукта
    const activeProductTypes = productTypes.filter(
        (type) => bookData?.[type.flag] === true
    );

// Сортируем обычные типы, если это книга
    const sortedAvailableBookTypes = availableBookTypes
        ? [...availableBookTypes].sort(
            (a, b) => bookTypeOrder.indexOf(a.key) - bookTypeOrder.indexOf(b.key)
        )
        : [];

// Выбираем, что показывать
    const displayTypes =
        bookData?.book_type === "product"
            ? activeProductTypes
            : sortedAvailableBookTypes;


    const handleBookTypeClick = (type) => {
        const selectedMarketplace =
            amzCountry?.selected_site ?? amzCountry?.amz_country ?? '';
        const hasMarketplace = Boolean(selectedMarketplace);
        const rqNum = Number(reviewQuality) || 0;
        const hasQuality = rqNum > 0;
        if (selectedBookType && selectedBookType?.key === type.key) {
            // Если текущий тип уже выбран, сбрасываем его
            setSelectedBookType(null);
            book.setSelectedBookType(null);
            book.setSelectedPrice('');
            setHasManualPriceChoice(false);
           book.setSelectedAssType('');
           setSearchQuery('');
           setSearchQueryLink('');
           setPromoCode('');
            setBookCostCompensation (null);
            setReviewQuality(null);
            setAmzCountry({
                amz_country: '',
                selected_site: '',
            });
            if (!hasMarketplace && !hasQuality) {
                setTargetingForecast({ ok: false });
                setForecastError('');
                setIsForecastLoading(false);
                          }

        } else {
            if (!hasMarketplace && !hasQuality) {
                setTargetingForecast({ ok: false });
                setForecastError('');
                setIsForecastLoading(false);
                         }
            // Устанавливаем новый выбранный тип
            setSelectedBookType(type);
            book.setSelectedBookType(type);
            if (mode === 'book') {
                setTotalCost(bookData.default_price);
            } else {
                setTotalCost(0);
            }

            setBookCostCompensation(null);
            setReviewQuality(null);
            book.setSelectedPrice('');
            setHasManualPriceChoice(false);
            book.setSelectedAssType('');
           setSearchQuery('');
           setSearchQueryLink('');
            setPromoCode('');
            setAmzCountry({
                amz_country: '',
                selected_site: '',
            });
        }
        const bookTypeKey = type.key;
        let allowedNames = assignmentMatrix[bookTypeKey] || [];

// аккуратно добавим Universal только при наличии файла
        if (hasLocalFile) {
            if (bookTypeKey === "kindle_flag" && !allowedNames.includes("Universal")) {
                allowedNames = ["Universal", ...allowedNames];
            }
            if (bookTypeKey === "paper_back_flag" && !allowedNames.includes("Universal")) {
                allowedNames = ["Universal", ...allowedNames];
            }
            if (bookTypeKey === "hard_cover_flag" && !allowedNames.includes("Universal")) {
                allowedNames = ["Universal", ...allowedNames];
            }
        }

        let filteredAssignments = book.asstypes.filter(assType =>
            allowedNames.includes(assType.ass_type_name)
        );

        if (
            bookTypeKey === "kindle_flag" &&
            bookData?.book_type !== "product" &&
            allowedNames.includes("Set Stars Rating") &&
            !filteredAssignments.some(ass => Number(ass.id) === 32)
        ) {
            filteredAssignments = [...filteredAssignments, SET_STARS_ASSIGNMENT];
        }
        setAvailableAssignments(filteredAssignments);


        // 4️⃣ Сбрасываем выбранный Assignment, если он не входит в новые доступные типы
        if (!filteredAssignments.some(ass => ass.id === book.selectedAssType?.id)) {
            book.setSelectedAssType(null);
        }

    };

    const displayAssignments =
        bookData?.book_type === "product"
            ? book.asstypes.filter(a => PRODUCT_ASSIGNMENT_IDS.includes(Number(a.id)))
            : availableAssignments;

    const internalHandleClose = () => {

        // 1️⃣ Сбрасываем флаги доступных типов книг
        setBookForAssignment({
            paper_back_flag: bookData?.paper_back_flag || false,
            kindle_flag: bookData?.kindle_flag || false,
            kindle_unlimited_flag: bookData?.kindle_unlimited_flag || false,
            hard_cover_flag: bookData?.hard_cover_flag || false,
            audio_flag: bookData?.audio_flag || false,
        });

        // 2️⃣ Сбрасываем выбор типа книги и типа ассигмента
        setSelectedBookType([]);
        book.setSelectedPrice('');
        setHasManualPriceChoice(false);
        book.setSelectedAssType('');
        setSearchQuery('');
        setSearchQueryLink('');
        setBookCostCompensation (null);
        setReviewQuality(null);
        setSelectedId(null);
        setBoostReviewMode(mode);
        // сбросим выборы, чтобы не было "залипших" цен/асс-тайпов
        book.setSelectedAssType(null);
        book.setSelectedPrice(null);
        setHasManualPriceChoice(false);
        // при Helpful/Report нам не нужен searchQuery и промокод
        setPromoCode('');

        // 3️⃣ Сбрасываем состояние интерфейса
        setHoveredItemId(null);
        setHoveredItem(null);
        setHoveredItemIdPrice(null);

        // 4️⃣ Очищаем список доступных типов заданий и цен
        setAvailableAssignments([]);
        setAvailablePrices([]);

        // 5️⃣ Сбрасываем общую стоимость и выбор дней
        setTotalCost(0);
        setBasePrice(0);
        setPriceAddition(0);
        setAssTypeAddition(0);
        setTotalWords(null);
        setTotalDiscount(0);
        setPriceTypeDiscount(0);
        setBookTypeDiscount(0);
        setAssTypeDiscount(0);
        setSiteAddition(0);
        setCurrency(null);
        setSelectedCountry("");
        setSelectedDays(null);
        setSpeedUp(0);
        setSpeedUpEffect({id: 0, sum: 0, label: "No Speed-Up Visual Effect"});
        setPromoDays (1);
        setPromoStartDate('');

        // 6️⃣ Сбрасываем загруженные файлы
        setUploadedFileName(null);
        setFileHash("");
        setSelectedBookType('');
        setPromoCode('');
        setAmzCountry({
            amz_country: '',
            selected_site: '',
        });

        // 7️⃣ Очищаем ошибки
        setError("");


        // 8️⃣ Закрываем модальное окно
        handleClose();
        if (onBookDataUpdate) {
            onBookDataUpdate(bookData.id); // Передаём ID книги, чтобы родитель обновился
        }
    };
    useEffect(() => {
        if (bookData) {
            setBookForAssignment({
                paper_back_flag: bookData?.paper_back_flag || false,
                kindle_flag: bookData?.kindle_flag || false,
                kindle_unlimited_flag: bookData?.kindle_unlimited_flag || false,
                hard_cover_flag: bookData?.hard_cover_flag || false,
                audio_flag: bookData?.audio_flag || false,
            });
        }
    }, [bookData, show]); // Перезапускаем при изменении `bookData` или открытии `show`
    const handleFileUpload = async ({ fileName, hash }) => {
        setIsUploading(true); // 🔹 Show loader

        try {
            setUploadedFileName(fileName);
            setFileHash(hash);

        } catch (error) {
            console.error("Error uploading file:", error);
          } finally {
            setIsUploading(false); // 🔹 Hide loader
        }
    };
    const handlePriceClick = (price) => {
        setHasManualPriceChoice(true);
        if (book.selectedPrice && book.selectedPrice.id === price.id) {

            // Если текущая цена уже выбрана, сбрасываем её
            book.setSelectedPrice('');
        } else {
            // Если выбрана другая цена, обновляем состояние
            book.setSelectedPrice(price);

        }
    };
// группы ID по типам ассигментов
    const PAPERBACK_IDS = [10, 11, 12, 13, 18, 19];
    const HARDCOVER_IDS = [14, 15, 16, 17, 20, 21];
    const PRODUCT_IDS   = [22, 23, 24, 25, 26, 27];

    const toNum = (v) => (v == null ? 0 : Number(v) || 0);

// для продукта: выбрать цену по выбранному типу (Type 1–4)
    const getProductPriceBySelectedType = () => {
        const key = book.selectedBookType?.key;   // "type1" | "type2" | "type3" | "type4"
        const id  = book.selectedBookType?.id;    // если ты используешь id 1..4

        // Приоритет по key, затем по id
        switch (key || `type${id}`) {
            case "type1": return toNum(bookData?.kindle_list_price_on_amazon_decimal);
            case "type2": return toNum(bookData?.paper_back_list_price_on_amazon_decimal);
            case "type3": return toNum(bookData?.hard_cover_list_price_on_amazon_decimal);
            case "type4": return toNum(bookData?.fourth_list_price_on_amazon_decimal);
            default: {
                // Fallback: возьми первую доступную цену из четырёх
                return (
                    toNum(bookData?.kindle_list_price_on_amazon_decimal)  ||
                    toNum(bookData?.paper_back_list_price_on_amazon_decimal) ||
                    toNum(bookData?.hard_cover_list_price_on_amazon_decimal)  ||
                    toNum(bookData?.fourth_list_price_on_amazon_decimal)
                );
            }
        }
    };

    const handleAssTypeClick = (assType) => {
        if (book.selectedAssType && book.selectedAssType?.id === assType.id) {
            // сброс
            book.setSelectedAssType('');
            book.setSelectedPrice('');
            setHasManualPriceChoice(false);
            setSearchQuery('');
            setSearchQueryLink('');
            setSiteAddition(0);
            setBookCostCompensation(null);
            setReviewQuality(null);
            setAmzCountry({ amz_country: '', selected_site: '' });
            setPromoCode('');
            return;
        }

        // выбор нового типа
        book.setSelectedAssType(assType);
        book.setSelectedPrice('');
        setHasManualPriceChoice(false);
        setSearchQuery('');
        setSearchQueryLink('');
        setReviewQuality(null);
        setSiteAddition(0);
        setAmzCountry({ amz_country: '', selected_site: '' });
        setPromoCode('');

        const id = Number(assType?.id);

        if (PAPERBACK_IDS.includes(id)) {
            setBookCostCompensation(toNum(bookData?.paper_back_list_price_on_amazon_decimal));
            return;
        }

        if (HARDCOVER_IDS.includes(id)) {
            setBookCostCompensation(toNum(bookData?.hard_cover_list_price_on_amazon_decimal));
            return;
        }

        if (PRODUCT_IDS.includes(id)) {
            // Ветка для продукта: цена зависит от выбранного "Type 1–4"
            const price = getProductPriceBySelectedType();
            setBookCostCompensation(price || null);
            return;
        }

        // по умолчанию
        setBookCostCompensation(null);
    };


    useEffect(() => {
        fetchGenre().then(data => book.setGenres(data));
        fetchTypes().then(data => book.setTypes(data));
        fetchAssTypes().then(data => book.setAssTypes(data));
        fetchLanguages().then(data => book.setLanguages(data));
        fetchPrices().then(data => book.setPrices(data));
           }, [book]);
    useEffect(() => {
        if (book.selectedCurrentUserBook.total_words) {
            setTotalWords(book.selectedCurrentUserBook.total_words);
        }
    }, [book.selectedCurrentUserBook.total_words]);
    useEffect(() => {
        if (selectedDays !== null && initialSelectedDays === null) {
            setInitialSelectedDays(selectedDays);
        }
    }, [selectedDays, initialSelectedDays]);
    const threeLineToast = (title, message, newBalance) => {
        toast.success(
            <div >
                <div style={{ fontSize: '14px', fontWeight: 'bold', lineHeight: '1.4' }}>{title}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{message}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{newBalance}</div>
            </div>,
            { position: "top-center", autoClose: 10000 }
        );
    };
    const goToEditBook = (e) => {
        e?.preventDefault();
        e?.stopPropagation?.(); // на случай, если родитель имеет onClick
        user?.setActiveComponent("EditBookInDashboard");
        // Закрыть модалку (выбери своё имя функции):
        if (typeof internalHandleClose === 'function') internalHandleClose();
    };

    function showThreeLineFromError(e, user, fallbackTitle = 'Action Failed') {
        const data = e?.response?.data ?? {};
        const title = (data.title && String(data.title).trim()) || fallbackTitle;
        const message = (data.message && String(data.message).trim()) || (e?.message ?? 'Something went wrong.');
        const virt = Math.floor(Number(user?.user?.balance ?? 0));
        const lrNum = Number(user?.user?.lr_balance);
        const hasLR = Number.isFinite(lrNum);
        const fallbackNewBalance = `Your new balance is now updated: ${virt} Virt.` + (hasLR ? ` and $${lrNum.toFixed(2)}` : '');
        const newBalance = (data.newBalance && String(data.newBalance).trim()) || fallbackNewBalance;

        threeLineToast(title, message, newBalance);
        return { title, message, newBalance };
    }

    // helper: типы с доставкой (бумажные/физические)
    const isPhysicalAssType = (id) => [10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(Number(id));

    const assTypeId = book?.selectedAssType?.id;
    const needsShippingGap = isPhysicalAssType(assTypeId);
    const SHIPPING_GAP_DAYS = needsShippingGap ? 10 : 0;

    const addAssign = async () => {
        if (mode === 'helpful') {
            if (!book.selectedAssType) {
                toast.error("Select Format of Assignment!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if ([28, 29].includes(book.selectedAssType?.id) && !inputUrl) {
                toast.error("Choose a Review from the List", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if ([28, 29, 30, 31].includes(book.selectedAssType?.id) && !inputUrl) {
                toast.error("Set Link to Existing Review", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
        } else {
            if (!book.selectedBookType || !selectedBookType) {
                toast.error("Select Book Format!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if (!book.selectedAssType) {
                toast.error("Select Type of Assignment!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if ([3, 4, 5, 6, 32].includes(book.selectedAssType?.id) && !book.selectedPrice?.id) {
                toast.error("Select Price!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if ([10, 11, 12, 13, 14, 15, 16, 17,18,19,20,21,22,23].includes(book.selectedAssType?.id) && !bookCostCompensation) {
                toast.error("Set Cost Compensation", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if ([4, 6].includes(book.selectedAssType?.id) && !fileHash) {
                toast.error("Upload Image!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if ([5, 6, 11, 15, 19, 21].includes(book.selectedAssType?.id) && !searchQuery) {
                toast.error("Enter a Search Query!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            const requiresPriceSelection = book.selectedAssType && [3, 4, 5, 6, 32].includes(book.selectedAssType?.id);
            if (requiresPriceSelection && !book.selectedPrice) {
                toast.error("Select Price for Assignment", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if (
                [3, 4, 32].includes(book.selectedAssType?.id) &&
                book.selectedBookType?.id === 1 &&
                book.selectedPrice?.id === 1
            ) {
                if (!promoStartDate) {
                    toast.error("Select Free Promotion Start Date!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    return;
                }

                if (!promoDays || ![1, 2, 3, 4, 5].includes(promoDays)) {
                    toast.error("Select Free Promotion Duration (1–5 days)!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    return;
                }
            }
            if (book.selectedAssType && [8].includes(book.selectedAssType.id)) {
                if (!promoCode) {
                    toast.error("Enter Promo Code Please!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    return;
                }

                if (!selectedCountry) {
                    toast.error("Enter Audible Country for Promo Code!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    return;
                }
            }
        }


        setLoading(true);
        setError("");
        const startRevDate = new Date();

        const turnaroundDays = selectedDays + SHIPPING_GAP_DAYS; // реальные сроки с доставкой
        const turnaroundMinutes = Math.floor(turnaroundDays * 24 * 60);
        try {
            const formData = new FormData();
            formData.append("bookId", bookData?.id);
            formData.append("userId", user?.user?.id);
            formData.append("assTypeId", book?.selectedAssType?.id);
            formData.append(
                "booksPriceId",
                book?.selectedPrice?.id
                    ? book.selectedPrice.id
                    : bookCostCompensation
                        ? 8
                        : 1
            );
            formData.append("booksGenreId", bookData.booksGenreId);
            formData.append("booksLanguageId", bookData.booksLanguageId);
            formData.append("booksTypeId", Number(book.selectedBookType.id));
            formData.append('rating_of_reviewer', Number(reviewQuality || 0));
            formData.append("start_rev_date", Math.floor(startRevDate.getTime() / 1000 / 60));
            formData.append("turnaround_time", String(turnaroundMinutes));
            formData.append(
                "assignment_type",
                Number(book.selectedAssType?.id) === 32 ? "Leave star rating" : book.selectedAssType.ass_type_todo
            );
            formData.append("assignment_price_amz", book.selectedPrice?.price ?? "Free Access");
            formData.append('book_cost_compensation', bookCostCompensation || 0);
            formData.append('assignment_search_term', searchQuery || "");
            formData.append('assignment_prefer_country', amzCountry.selected_site || ""); // для теста, тут будет список.
            formData.append('audio_promo_code_country', selectedCountry || "");
            formData.append('assignment_status', "NEW");
            formData.append('audio_promo_code', promoCode);
            formData.append("reviewer_reading_step", "NO_STEP" );
            formData.append("assignment_price_reader", `${Number(totalCost -
            (book?.selectedAssType?.ass_price_shift + (book?.selectedPrice?.price_shift || 0)))}`);
            formData.append("assignment_price_publisher", `${totalCost-totalDiscount}`);
            formData.append('message_to_publisher', '');
            if (
                [3, 4, 32].includes(book.selectedAssType?.id) &&
                Number(book.selectedBookType?.id) === 1 &&
                Number(book.selectedPrice?.id) === 1
            ) {
                formData.append("free_promotion_start_date", promoStartDate);
                formData.append("free_promotion_duration", promoDays);
            }
            formData.append("speed_up_level", speedUpEffect.id || 0)
            formData.append("assignment_book_img", bookData.cover_file);

            formData.append('assignment_img1', uploadedFileName);  //Для отзыва с фото заготовка
            formData.append('assignment_img1_hash', fileHash); // Для проверки условной уникальности фото

            formData.append('title', bookData.title);  //Для генерации нового имени
            formData.append('review_link', inputUrl);

            // 📌 Рассчитываем новый баланс
            const newBalance = user?.user?.balance - (totalCost - totalDiscount);
            if (newBalance < 0) {
                toast.error(
                    <div style={{ marginLeft: '6px' }}>
                        <div style={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Sorry, Not Enough Virt to Pay</div>
                        <div className="text-muted" style={{ fontWeight: 'italic', fontSize: '0.85rem' }}>Try To Earn More Virt By Taking Assignments Or Doing Polls!</div>
                    </div>,
                    { position: "bottom-center", autoClose: 8000 }
                );
                setLoading(false);
                return;
            }

            const updatedAssignmentData = await createAssignment(formData);

            threeLineToast(updatedAssignmentData.title, updatedAssignmentData.message, updatedAssignmentData.newBalance);

            // 📌 Обновляем баланс в MobX store
            const data = await check();
            user.setUser(data);

            // 📌 Обновляем список ассигнментов
            const updatedAssigns = await fetchCurrentUserAssigns(user?.user?.id);
            book.setAssignmentsForThisBook(updatedAssigns);

            // 📌 Закрываем окно
            internalHandleClose();
        } catch (e) {
            showThreeLineFromError(e, user, 'Assignment Creation Failed');
            setError(e?.response?.data?.message || e?.message || 'Something went wrong.');
        }
        finally {
            setLoading(false);
        }
    };

    // helpers (положи рядом в компоненте)
    const fmtPrice = (val) => {
        if (val == null) return null;
        const n = parseFloat(String(val).replace(',', '.').replace(/[^\d.]/g, ''));
        if (!Number.isFinite(n) || n <= 0) return null;   // ← цена должна быть > 0
        return `$${n.toFixed(2)}`;
    };

    const moneyToCents = useCallback((val) => {
        if (val == null) return null;
        const n = parseFloat(String(val).replace(',', '.').replace(/[^\d.]/g, ''));
        if (!Number.isFinite(n) || n <= 0) return null;
        return Math.round(n * 100);
    }, []);

    const firstKnownPriceCents = useCallback((...values) => {
        for (const value of values) {
            const cents = moneyToCents(value);
            if (cents != null) return cents;
        }
        return null;
    }, [moneyToCents]);

    const getSelectedFormatPriceCents = useCallback(() => {
        const key = selectedBookType?.key || book.selectedBookType?.key;

        switch (key) {
            case 'kindle_flag':
            case 'type1':
                return firstKnownPriceCents(
                    bookData?.kindle_list_price_on_amazon_decimal,
                    bookData?.kindle_price_on_amazon
                );
            case 'paper_back_flag':
            case 'type2':
                return firstKnownPriceCents(
                    bookData?.paper_back_list_price_on_amazon_decimal,
                    bookData?.paper_back_price_on_amazon
                );
            case 'hard_cover_flag':
            case 'type3':
                return firstKnownPriceCents(
                    bookData?.hard_cover_list_price_on_amazon_decimal,
                    bookData?.hard_cover_price_on_amazon
                );
            case 'audio_flag':
            case 'type4':
                return firstKnownPriceCents(
                    bookData?.fourth_list_price_on_amazon_decimal,
                    bookData?.fourth_price_on_amazon
                );
            default:
                return null;
        }
    }, [
        book.selectedBookType?.key,
        bookData?.fourth_list_price_on_amazon_decimal,
        bookData?.fourth_price_on_amazon,
        bookData?.hard_cover_list_price_on_amazon_decimal,
        bookData?.hard_cover_price_on_amazon,
        bookData?.kindle_list_price_on_amazon_decimal,
        bookData?.kindle_price_on_amazon,
        bookData?.paper_back_list_price_on_amazon_decimal,
        bookData?.paper_back_price_on_amazon,
        firstKnownPriceCents,
        selectedBookType?.key,
    ]);

    useEffect(() => {
        if (hasManualPriceChoice) return;
        if (!book.selectedAssType?.id) return;
        if (book.selectedPrice?.id) return;
        if (!availablePrices.length) return;

        const knownPriceCents = getSelectedFormatPriceCents();
        if (knownPriceCents == null) return;

        const matchingPrice = availablePrices.find(
            (price) => moneyToCents(price?.price_for_creating) === knownPriceCents
        );

        if (matchingPrice) {
            book.setSelectedPrice(matchingPrice);
        }
    }, [
        availablePrices,
        book,
        book.selectedAssType?.id,
        book.selectedPrice?.id,
        getSelectedFormatPriceCents,
        hasManualPriceChoice,
        moneyToCents,
    ]);

    const shortDate = (sec) => {
        const ts = Number(sec);
        if (!Number.isFinite(ts) || ts <= 0) return null;
        return new Date(ts * 1000).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

// формируем подписи
    const priceLabels = [
        fmtPrice(bookData?.kindle_price_on_amazon) && `Kindle: ${fmtPrice(bookData?.kindle_price_on_amazon)}`,
        fmtPrice(bookData?.paper_back_price_on_amazon) && `Paperback: ${fmtPrice(bookData?.paper_back_price_on_amazon)}`,
        fmtPrice(bookData?.hard_cover_price_on_amazon) && `Hardcover: ${fmtPrice(bookData?.hard_cover_price_on_amazon)}`,
    ].filter(Boolean);

    const hasCompletedLibraryOffer = Number(userCount?.userTakenAssConfirmedCount || 0) >= 1;

    const lastUpd = shortDate(bookData?.last_update_book_data_from_amazon_date);

// где-то вверху файла (рядом с assignmentHints)
    const boostHints = {
        'helpful-v': (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Make Helpful" involve?</h6>
                    <span>
          With this assignment type, you can boost any review that was received for <b>this book</b> through Virtalibry.
          The reader will find the target review on Amazon, click the <b>“Helpful”</b> button, take a clear screenshot
          (showing the review and the Helpful action), and upload it to the system. You will see this screenshot in the
          reviewer’s results after completion. <br />
          Clicking “Helpful” usually increases the visibility of that review on the Amazon listing, pushing it higher
          in the “Top reviews” section and helping it reach more potential readers.
        </span>
                </div>
            </>
        ),

        'report-v': (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Write Report" involve?</h6>
                    <span>
          With this assignment type, you can report any review that was received for <b>this book</b> through Virtalibry.
          The reader will open the target review on Amazon, click <b>“Report”</b> (selecting a reason if required),
          take a clear screenshot of the report action, and upload it to the system. You will see this
          screenshot in the reviewer’s results after completion. <br />
          Submitting such reports by multiple users typically lowers the visibility of that review on the Amazon listing
          and may eventually lead to its removal by Amazon’s moderation system.
        </span>
                </div>
            </>
        ),

        'helpful-any': (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Make Helpful Any Review" involve?</h6>
                    <span>
          This assignment lets you boost <b>any review</b> posted under <b>this book</b>, even if the review was not
          obtained through Virtalibry. The reader will locate the chosen review on Amazon, click the <b>“Helpful”</b> button, take a clear screenshot (including the review and the Helpful action), and upload it as proof.
          You will see this screenshot in the reviewer’s results after completion. <br />
          Marking a review as “Helpful” helps it appear higher in search and listing results, making positive reviews
          more visible to new customers browsing your book.
        </span>
                </div>
            </>
        ),

        'report-any': (
            <>
                <div className="d-flex flex-column small text-muted mt-2">
                    <h6 className="mb-1 mt-2 text-muted">What does "Write Report to Any Review" involve?</h6>
                    <span>
          This assignment lets you report <b>any review</b> under <b>this book</b>, regardless of how that review was obtained.
          The reader will open the selected review on Amazon, click <b>“Report”</b> (choosing a reason if required),
          take a clear screenshot showing the report action, and upload it to the system. You will see this
          screenshot in the reviewer’s results after completion. <br />
          Submitting similar reports from multiple users usually lowers the ranking of that review and can potentially
          trigger Amazon’s moderation system to remove it entirely.
        </span>
                </div>
            </>
        ),
    };

    const applySelection = (a, bookTypeId, assTypeId, priceId) => {
        setSelectedId(a.id);
        setInputUrl(a.review_link);

        const bookTypeObj = book.types?.find(t => t.id === bookTypeId);
        setSelectedBookType(bookTypeObj);
        const assTypeObj  = book.asstypes?.find(t => t.id === assTypeId);
        const priceObj    = book.prices?.find(p => p.id === priceId);

        if (bookTypeObj) book.setSelectedBookType(bookTypeObj);
        if (assTypeObj)  book.setSelectedAssType(assTypeObj);
        if (priceObj)    book.setSelectedPrice(priceObj);
    };

// допустимые режимы
    const MODES = new Set(['helpful-v','report-v','helpful-any','report-any']);

// ⚙️ режим → ID (подставь свои реальные)
    const MODE_TO_IDS = {
        'helpful-v':   { bookTypeId: 5, assTypeId: 28, priceId: 1 },
        'report-v':    { bookTypeId: 6, assTypeId: 29, priceId: 1 },
        'helpful-any': { bookTypeId: 5, assTypeId: 30, priceId: 1 },
        'report-any':  { bookTypeId: 6, assTypeId: 31, priceId: 1 },
    };

// ❗ никакого default — пока пользователь не выбрал режим, ничего не подставляем
    const resolveIds = (mode) => (mode && MODES.has(String(mode).toLowerCase()))
        ? MODE_TO_IDS[String(mode).toLowerCase()]
        : null;

    useEffect(() => {
        // базовая цена
        const base = (mode === 'book')
            ? (bookData?.default_price ? bookData.default_price : 0)
            : 100;

        // надбавки
        const btAdd = book.selectedBookType?.book_type_price_addition || 0;
        const atAdd = book.selectedAssType?.ass_price || 0;
        const pAdd  = book.selectedPrice?.price_addition || 0;

        // скидки по окнам дат
        const nowMin = Math.floor(Date.now() / 60000);

        const BTdiscount = (book.selectedBookType?.promotion_discount &&
            book.selectedBookType?.promotion_discount_start &&
            book.selectedBookType?.promotion_discount_end &&
            nowMin >= book.selectedBookType.promotion_discount_start &&
            nowMin <= book.selectedBookType.promotion_discount_end)
            ? book.selectedBookType.promotion_discount : 0;

        const ATdiscount = (book.selectedAssType?.promotion_ass_price_discount &&
            book.selectedAssType?.promotion_ass_price_discount_start_date &&
            book.selectedAssType?.promotion_ass_price_discount_end_date &&
            nowMin >= book.selectedAssType.promotion_ass_price_discount_start_date &&
            nowMin <= book.selectedAssType.promotion_ass_price_discount_end_date)
            ? book.selectedAssType.promotion_ass_price_discount : 0;

        const PTdiscount = (book.selectedPrice?.promotion_price_discount &&
            book.selectedPrice?.promotion_price_discount_start_date &&
            book.selectedPrice?.promotion_price_discount_end_date &&
            nowMin >= book.selectedPrice.promotion_price_discount_start_date &&
            nowMin <= book.selectedPrice.promotion_price_discount_end_date)
            ? book.selectedPrice.promotion_price_discount : 0;

        const final = base + btAdd + pAdd + atAdd + currency + siteAddition
            + Number(speedUp) + Number(speedUpEffect.sum);
        const discSum = BTdiscount + ATdiscount + PTdiscount;

        setBasePrice(base);
        setPriceAddition(pAdd);
        setAssTypeAddition(atAdd);
        setTotalCost(final);
        setTotalDiscount(discSum);
        // setSiteAddition(siteAddition) не нужен — ты и так читаешь его из state
    }, [
        mode, bookData?.default_price,
        book.selectedBookType, book.selectedAssType, book.selectedPrice,
        currency, siteAddition, speedUp, speedUpEffect.sum
    ]);

    useEffect(() => {
        const ids = resolveIds(boostReviewMode);

        if (!ids) {
            // режим не выбран — очищаем, чтобы не было «плюса» у Assignment Type
            book.setSelectedAssType(null);
            book.setSelectedPrice(null);
            setHasManualPriceChoice(false);
            setSelectedBookType(null);
            setInputUrl('');
            setAmzCountry({ amz_country: '', selected_site: '' });
            setReviewQuality(0);
            return;
        }

        const btObj = book.types?.find(t => t.id === ids.bookTypeId) || null;
        const atObj = book.asstypes?.find(t => t.id === ids.assTypeId) || null;
        const pObj  = book.prices?.find(p => p.id === ids.priceId) || null;

        if (btObj) { setSelectedBookType(btObj); book.setSelectedBookType(btObj); }
        if (atObj)  book.setSelectedAssType(atObj);
        if (pObj)   book.setSelectedPrice(pObj);

        if (selectedId && Array.isArray(assignmentsForThisBook) && assignmentsForThisBook.length) {
            const row = assignmentsForThisBook.find(x => x.id === selectedId);
            setInputUrl(row?.review_link || '');
        } else {
            setInputUrl('');
        }

        setAmzCountry({ amz_country: '', selected_site: '' });
        setReviewQuality(0);
    }, [
        boostReviewMode,
        selectedId, assignmentsForThisBook,
        book.types, book.asstypes, book.prices
    ]);



    const handleBoostModeChange = (mode) => {
        setBoostReviewMode(mode);
        // сбросим выборы, чтобы не было "залипших" цен/асс-тайпов
        book.setSelectedAssType(null);
        book.setSelectedPrice(null);
        setHasManualPriceChoice(false);
        // при Helpful/Report нам не нужен searchQuery и промокод
        setSearchQuery('');
        setSearchQueryLink('');
        setPromoCode('');
    };

    const allowedAsins = [
        bookData?.kindle_asin,
        bookData?.paper_back_asin,
        bookData?.hard_cover_asin,
        bookData?.audible_asin,
    ].filter(Boolean);



    return (
        <>
        <DownloadProgressModal
            show={downloadModal.show}
            progress={downloadModal.progress}
            status={downloadModal.status}
        />
        <Modal show={show} onHide={() => { setError(''); handleClose(); }} top className="modal-lg">

            <div className="modal-content modal-lg">
                <div className="modal-header small" style={{height:40}}>
                    <h6 className="modal-title fs-6">
                        Creating Assignment:
                    </h6>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            internalHandleClose();
                        }}
                    ></button>
                </div>
                {loading ? <Loader /> : <>
                {!hasCompletedLibraryOffer && (
                    <div className="alert alert-warning p-3 mt-3 mb-1 border rounded border border-secondary mx-auto small"
                         style={{ maxWidth: '80%', width: '70%' }}>
                        <h5 className="mb-2 text-center">One quick starter step</h5>
                        <p className="mb-1">
                            Before posting an assignment for your own book, please take <strong>at least one offer from the Library</strong>, complete it, and wait for approval.
                        </p>

                         <p className="mb-1">
                            This helps us make sure your Amazon review flow is working smoothly before other members review your book. Currently, you have <strong>{userCount?.userTakenAssConfirmedCount}</strong> approved completed offer(s).
                        </p>
                        <p className="mb-1">
                            Visit the <strong>Library</strong>, choose any suitable offer, and once it is completed and approved, you will be able to post your own assignment.
                        </p>

                    </div>
                )}



                <div className="modal-body">

                    {/* Родительский контейнер с position-relative */}
                    <div className="position-relative mb-3">
                        <h6 className="fw-semibold text-muted">
                            {mode === 'helpful'
                                ? 'Choose the number of days to complete this assignment.'
                                : (
                                    <>
                                        {bookData?.book_type === 'product'
                                            ? "Choose the number of days your participant will have to review your product."
                                            : "Choose the number of days your reader will read your book and post review."}
                                        {" "}
                                        <span className="fw-normal">
                                            (recommended: {initialSelectedDays} days
                                            {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(Number(book?.selectedAssType?.id)) && " + 10 days delivery"})
                                        </span>
                                    </>
                                )}
                        </h6>

                        <p className="d-none">
                            {mode === 'helpful' ? (
                                <>The recommended completion time depends on your task’s complexity.</>
                            ) : (
                                <>
                                    The recommended days based on your product/book data: {initialSelectedDays} days
                                    { [10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(Number(book?.selectedAssType?.id)) && (
                                        <> + 10 days for delivery</>
                                    )}
                                </>
                            )}
                        </p>



                    </div>
                    <div className="d-flex justify-content-center mb-1">
                        <DaysSwitcher
                            totalWords={totalWords}
                            selectedDays={selectedDays}
                            setSelectedDays={setSelectedDays}
                            setCurrency={setCurrency}
                            displayOffsetDays={SHIPPING_GAP_DAYS}   // <-- только отображение!
                        />
                    </div>
                    {mode === 'book' && (<>
                        <h6 className="mb-3 text-muted">
                            {bookData.book_type === 'product' ? "This Product is available in such Types. ":"This book is available in such formats. "}
                            Please select one of them.
                        </h6>
                        <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                            {displayTypes.map((type) => (
                                <Button
                                    key={type.key}
                                    variant={
                                        hoveredItem === type.key || selectedBookType?.key === type.key
                                            ? "success"
                                            : "outline-success"
                                    }
                                    className="btn-sm d-inline-flex align-items-center"
                                    style={{
                                        transition: "transform 0.2s",
                                        transform: hoveredItem === type.key ? "scale(1.05)" : "scale(1)",
                                        padding: '0.35rem 0.5rem',
                                        fontSize: '0.85rem',
                                        lineHeight: '1.2',
                                    }}
                                    onMouseEnter={() => setHoveredItem(type.key)}
                                    onMouseLeave={() => setHoveredItem(null)}
                                    onClick={() => handleBookTypeClick(type)}
                                >
                                    <i
                                        className="fa-solid fa-circle-check me-2"
                                        style={{
                                            color:
                                                hoveredItem === type.key || selectedBookType?.key === type.key
                                                    ? "white"
                                                    : "green",
                                        }}
                                    ></i>
                                    {type.label}
                                </Button>
                            ))}
                        </div>
                    </>)}

                    {mode === 'helpful' && (<>
                        <h6 className="mb-3 text-muted">
                            This assignment is available in such formats. Please select one of them.
                        </h6>
                        <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                            {/* Make Helpful */}
                            <Button
                                variant={
                                    hoveredItem === 'helpful-v' || boostReviewMode === 'helpful-v'
                                        ? 'success'
                                        : 'outline-success'
                                }
                                className="btn-sm d-inline-flex align-items-center"
                                style={{
                                    transition: 'transform 0.2s',
                                    transform: hoveredItem === 'helpful-v' ? 'scale(1.05)' : 'scale(1)',
                                    padding: '0.35rem 0.5rem',
                                    fontSize: '0.85rem',
                                    lineHeight: '1.2',
                                }}
                                onMouseEnter={() => setHoveredItem('helpful-v')}
                                onMouseLeave={() => setHoveredItem(null)}
                                onClick={() => handleBoostModeChange('helpful-v')}
                            >
                                <i
                                    className="fa-solid fa-circle-up me-2"
                                    style={{
                                        color:
                                            hoveredItem === 'helpful-v' || boostReviewMode === 'helpful-v'
                                                ? 'white'
                                                : 'green',
                                    }}
                                ></i>
                                Make Helpful
                            </Button>

                            {/* Write Report */}
                            <Button
                                variant={
                                    hoveredItem === 'report-v' || boostReviewMode === 'report-v'
                                        ? 'danger'
                                        : 'outline-danger'
                                }
                                className="btn-sm d-inline-flex align-items-center"
                                style={{
                                    transition: 'transform 0.2s',
                                    transform: hoveredItem === 'report-v' ? 'scale(1.05)' : 'scale(1)',
                                    padding: '0.35rem 0.5rem',
                                    fontSize: '0.85rem',
                                    lineHeight: '1.2',
                                }}
                                onMouseEnter={() => setHoveredItem('report-v')}
                                onMouseLeave={() => setHoveredItem(null)}
                                onClick={() => handleBoostModeChange('report-v')}
                            >
                                <i
                                    className="fa-solid fa-circle-down me-2"
                                    style={{
                                        color:
                                            hoveredItem === 'report-v' || boostReviewMode === 'report-v'
                                                ? 'white'
                                                : 'red',
                                    }}
                                ></i>
                                Write Report
                            </Button>
                            {/* Make Helpful */}
                            <Button
                                variant={
                                    hoveredItem === 'helpful-any' || boostReviewMode === 'helpful-any'
                                        ? 'success'
                                        : 'outline-success'
                                }
                                className="btn-sm d-inline-flex align-items-center"
                                style={{
                                    transition: 'transform 0.2s',
                                    transform: hoveredItem === 'helpful-any' ? 'scale(1.05)' : 'scale(1)',
                                    padding: '0.35rem 0.5rem',
                                    fontSize: '0.85rem',
                                    lineHeight: '1.2',
                                }}
                                onMouseEnter={() => setHoveredItem('helpful-any')}
                                onMouseLeave={() => setHoveredItem(null)}
                                onClick={() => handleBoostModeChange('helpful-any')}
                            >
                                <i
                                    className="fa-solid fa-circle-up me-2"
                                    style={{
                                        color:
                                            hoveredItem === 'helpful-any' || boostReviewMode === 'helpful-any'
                                                ? 'white'
                                                : 'green',
                                    }}
                                ></i>
                                Make Helpful Any Review
                            </Button>

                            {/* Write Report */}
                            <Button
                                variant={
                                    hoveredItem === 'report-any' || boostReviewMode === 'report-any'
                                        ? 'danger'
                                        : 'outline-danger'
                                }
                                className="btn-sm d-inline-flex align-items-center"
                                style={{
                                    transition: 'transform 0.2s',
                                    transform: hoveredItem === 'report-any' ? 'scale(1.05)' : 'scale(1)',
                                    padding: '0.35rem 0.5rem',
                                    fontSize: '0.85rem',
                                    lineHeight: '1.2',
                                }}
                                onMouseEnter={() => setHoveredItem('report-any')}
                                onMouseLeave={() => setHoveredItem(null)}
                                onClick={() => handleBoostModeChange('report-any')}
                            >
                                <i
                                    className="fa-solid fa-circle-down me-2"
                                    style={{
                                        color:
                                            hoveredItem === 'report-any' || boostReviewMode === 'report-any'
                                                ? 'white'
                                                : 'red',
                                    }}
                                ></i>
                                Write Report to Any Review
                            </Button>

                        </div>



                    </>)}
                    {/* Hints for boostReviewMode */}
                    <div className="mt-2 mb-2">
                        {boostReviewMode
                            && (<>{boostHints[boostReviewMode]}
                                {(boostReviewMode === 'helpful-v' || boostReviewMode === 'report-v') && (
                                    <div className="d-flex flex-column mt-2 gap-2">
                                       {/* Таблица с выбором (SUCCESS only) */}
                                        <div className="d-flex justify-content-between align-items-center pt-1">
                                            <h6 className="mb-1 mt-1 text-muted">
                                                {selectedId
                                                    ? 'Assignment selected — you can post now.'
                                                    : 'Select an assignment in the table below.'}
                                            </h6>

                                        </div>
                                        <div
                                            className="border rounded"
                                            style={{ maxHeight: 360, overflow: 'auto' }} /* прокрутка */
                                        >
                                            <table className="table table-sm mb-0 align-middle small" style={{ lineHeight: '18px' }}>
                                                <thead className="table-light sticky-top" style={{ top: selectedAssign ? 0 : 0, zIndex: 4, lineHeight: '18px' }}>
                                                <tr>
                                                    <th style={{ width: 30 }}></th>
                                                    <th>Reviewer</th>
                                                    <th>Title</th>
                                                    <th style={{ width: 80 }}>Stars</th>
                                                    <th style={{ width: 90 }}>VP</th>
                                                    <th style={{ width: 110 }}>Link</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {assignmentsForThisBook
                                                    ?.filter(a =>
                                                        a?.assignment_status === 'SUCCESS' &&
                                                        (a?.check_status === 'COMPLETE' ||
                                                        a?.check_status === 'DECLINED') &&
                                                        ![28, 29, 30, 31, 32].includes(a?.assTypeId)
                                                    )
                                                    .map(a => (
                                                        <tr
                                                            key={a.id}
                                                            className={a.id === selectedId ? 'table-success' : ''}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                const { bookTypeId, assTypeId, priceId } = resolveIds(boostReviewMode);
                                                                applySelection(a, bookTypeId, assTypeId, priceId);
                                                            }}
                                                        >
                                                            <td className="text-center">
                                                                <input
                                                                    type="radio"
                                                                    name="assignRow"
                                                                    checked={a.id === selectedId}
                                                                    onChange={() => {
                                                                        const { bookTypeId, assTypeId, priceId } = resolveIds(boostReviewMode);
                                                                        applySelection(a, bookTypeId, assTypeId, priceId);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-truncate" title={a.reviewer_name || ''}>
                                                                {a.reviewer_name || '—'}
                                                            </td>
                                                            <td className="text-truncate" title={a.review_title || ''}>
                                                                {a.checked_review_title
                                                                    ? a.checked_review_title.length > 40
                                                                        ? a.checked_review_title.slice(0, 40) + '…'
                                                                        : a.checked_review_title
                                                                    : '—'}
                                                            </td>
                                                            <td>⭐ {a.rating || '-'}</td>
                                                            <td>{a.checked_review_status ? '✅' : '—'}</td>
                                                            <td>
                                                                {a.review_link ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link btn-sm p-0"
                                                                        onClick={() => openRedirectedLink(a.review_link)}
                                                                    >
                                                                        Open Review
                                                                    </button>
                                                                ) : (
                                                                    '—'
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            {assignmentsForThisBook.filter(a => a.assignment_status === 'SUCCESS').length === 0 && (
                                                <div className="p-3 text-muted small">No confirmed assignments yet.</div>
                                            )}

                                        </div>
                                        {/* Превью выбранного ассигмента (стикнуто сверху) */}
                                        {selectedAssign && (
                                            <div
                                                style={{
                                                    position: 'sticky',
                                                    top: 10,
                                                    zIndex: 5,
                                                    background: 'white',
                                                    display: 'flex',
                                                    justifyContent: 'center', // центрирует по горизонтали
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: window.innerWidth > 992 ? '50%' : '100%', // 50% на десктопе, 100% на мобильных
                                                    }}
                                                    className="mt-2"
                                                >
                                                    <AssignUnderBookS4
                                                        assign={selectedAssign}
                                                        updateAssignments={() =>
                                                            fetchAssignmentsForThisBook(bookData.id).then(setAssignmentsForThisBook)
                                                        }
                                                        isLinked={false}
                                                    />
                                                </div>
                                            </div>

                                        )}

                                    </div>
                                )}
                                {(boostReviewMode === 'helpful-any' || boostReviewMode === 'report-any') && (
                                    <Card className="mt-3 p-3 shadow-sm rounded w-100">
                                        <ReviewOwnershipCheck
                                            allowedAsins={[
                                                bookData?.kindle_asin,
                                                bookData?.paper_back_asin,
                                                bookData?.hard_cover_asin,
                                                bookData?.audible_asin,
                                            ].filter(Boolean)}
                                            initialLink={inputUrl || ""}
                                            onVerified={({ link }) => setInputUrl(link)}
                                            onFail={(reason) => console.warn(reason)}
                                        />
                                    </Card>
                                )}



                            </>)}
                    </div>






                    {selectedBookType && selectedBookType.key && (
                        <>
                            <div className="mt-3 position-relative">
                                {book.selectedAssType?.id ? (
                                    <InfoTitle
                                        className="mb-3"
                                        helpTitle={`What does "${book.selectedAssType?.ass_type_name}" assignment type involve?`}
                                        helpContent={assignmentHint}
                                    >
                                        Select assignment type{" "}
                                        <span className="fw-normal">
                                            (What does "{book.selectedAssType?.ass_type_name}" involve?)
                                        </span>
                                    </InfoTitle>
                                ) : (
                                    <h6 className="mb-3 text-muted">Select assignment type:</h6>
                                )}


                            </div>

                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-3">
                                {displayAssignments.length > 0 ? (
                                    displayAssignments.map((assignment) => (
                                        <Button
                                            key={assignment.id}
                                            variant={
                                                hoveredItemId === assignment.id || book.selectedAssType?.id === assignment.id
                                                    ? "success"
                                                    : "outline-success"
                                            }
                                            className="btn-sm d-inline-flex align-items-center"
                                            style={{
                                                transition: "transform 0.2s",
                                                transform: hoveredItemId === assignment.id ? "scale(1.05)" : "scale(1)",
                                                padding: '0.35rem 0.5rem',
                                                fontSize: '0.85rem',
                                                lineHeight: '1.2',
                                            }}

                                            onMouseEnter={() => setHoveredItemId(assignment.id)}
                                            onMouseLeave={() => setHoveredItemId(null)}
                                            onClick={() => handleAssTypeClick(assignment)}
                                        >
                                            {Number(assignment.id) === 32 ? (
                                                <FaStar
                                                    className="me-2"
                                                    style={{
                                                        color:
                                                            hoveredItemId === assignment.id || book.selectedAssType?.id === assignment.id
                                                                ? "white"
                                                                : "green",
                                                    }}
                                                />
                                            ) : (
                                                <i
                                                    className="fa-solid fa-circle-check me-2"
                                                    style={{
                                                        color:
                                                            hoveredItemId === assignment.id || book.selectedAssType?.id === assignment.id
                                                                ? "white"
                                                                : "green",
                                                    }}
                                                ></i>
                                            )}
                                            {assignment.ass_type_name}
                                        </Button>
                                    ))
                                ) : (
                                    <p className="text-muted">No assignments available for this format.</p>
                                )}
                            </div>
                        </>
                    )}


                    {book.selectedAssType && availablePrices.length > 0 && availableBookTypes.length > 0 ? (
                        <>
                            <div className="mt-3 position-relative">
                                <h6 className="mb-1 text-muted">
                                    For this type of assignment, the following prices are available. Please select one:
                                </h6>
                                <p className="fst-normal small mb-3 text-muted">
                                    {priceLabels.length > 0 && <> Prices recorded at last update: <span className="fw-semibold">{priceLabels.join(", ")}</span>.</>}
                                    {lastUpd && <> Recorded at: {lastUpd}.</>}
                                </p>


                            </div>

                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                                {availablePrices.map((price) => (
                                    <Button
                                        key={price.id}
                                        variant={
                                            hoveredItemIdPrice === price.id || book.selectedPrice?.id === price.id
                                                ? "success"
                                                : "outline-success"
                                        }
                                        className="btn-sm d-inline-flex align-items-center"
                                        style={{
                                            transition: "transform 0.2s",
                                            transform: hoveredItemIdPrice === price.id ? "scale(1.05)" : "scale(1)",
                                            padding: '0.35rem 0.35rem',
                                            fontSize: '0.85rem',
                                            lineHeight: '1.2',
                                        }}
                                        onMouseEnter={() => setHoveredItemIdPrice(price.id)}
                                        onMouseLeave={() => setHoveredItemIdPrice(null)}
                                        onClick={() => handlePriceClick(price)}
                                    >
                                        <FaDollarSign className="me-0" />
                                        {price.price_for_creating}
                                    </Button>
                                ))}
                            </div>

                        </>


                    ) : ('')}

                    {selectedBookType &&
                    selectedBookType.key &&
                    book.selectedAssType &&
                    [5, 6, 11, 15, 19, 21, 23, 27].includes(Number(book.selectedAssType?.id)) ? (     <>
                            <div className="d-flex flex-column gap-2 mt-3">
                                <h6 htmlFor="searchQuery" className="text-muted">
                                    Enter Search Query:
                                </h6>

                                <input
                                    type="text"
                                    id="searchQuery"
                                    className="form-control form-control-sm border border-secondary"
                                    placeholder="e.g. Self-help books"
                                    maxLength="100"
                                    value={searchQuery}
                                    onChange={handleSearchQueryChange}
                                    style={{ maxWidth: '400px' }}
                                />

                                <small className="text-muted">Maximum 100 characters.</small>

                                <span className="text-muted small">
                                    Please make sure that the reader can find your book within the first seven pages of Amazon search results.
                                    The best practice is to have your book appear within the first three pages for this query.
                                    <br />
                                    Please test this before posting. Otherwise, there's a higher chance that readers will accept your assignment,
                                    attempt to find the book, fail, and abandon the task. So it's in your best interest to ensure it's easily discoverable.
                                    <br />
                                    Also, make sure that you don’t have any active advertising campaigns for this search query, as it may lead to overspending.
                                </span>

                                <div className="mt-1 mb-2 small lh-3 fw-bolder text-muted">
                                    Here is the purchase link that your readers will receive:{' '}
                                    {searchQueryLink ? (
                                        <span
                                            onClick={() => openRedirectedLink(searchQueryLink)}
                                            className="text-decoration-none fw-bold text-primary"
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                        >
        🔍 Search on Amazon
    </span>
                                    ) : (
                                        <span className="text-danger">
        No Link Available! Enter a Search Query!
    </span>
                                    )}
                                </div>
                            </div>
                        </>

                    ) : (
                        '' // 🔹 Если ничего не выбрано
                    )}

                    {Number(book.selectedPrice?.id) === 1 && [3, 4, 32].includes(Number(book.selectedAssType?.id)) && (
                        <>
                            <div className="d-flex flex-column gap-3 mt-4 mb-0 me-3" style={{ maxWidth: '800px' }}>
                                <div className="border border-secondary border-opacity-50 rounded p-2 d-flex flex-column gap-2">
                                    <div className="d-flex flex-column flex-md-row align-items-center gap-3">
                                        <h6
                                            className="mb-0 ms-1 text-muted"
                                            style={{
                                                lineHeight: '1.2',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '100%'
                                            }}
                                        >
                                            Set Free Promotion Start Date and Duration:
                                        </h6>

                                        <div className="d-flex flex-column flex-md-row gap-3 ms-md-auto">
                                            <Form.Group style={{ width: '150px' }}>
                                                <Form.Label className="visually-hidden">Start Date</Form.Label>
                                                <Form.Control
                                                    size="sm"
                                                    type="date"
                                                    className="border-success"
                                                    value={promoStartDate}
                                                    onChange={(e) => setPromoStartDate(e.target.value)}
                                                />
                                            </Form.Group>

                                            <Form.Group style={{ width: '150px' }}>
                                                <Form.Label className="visually-hidden">Number of Days</Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    value={promoDays}
                                                    className="border-success"
                                                    onChange={(e) => setPromoDays(Number(e.target.value))}
                                                >
                                                    {[1, 2, 3, 4, 5].map((day) => (
                                                        <option key={day} value={day}>
                                                            {day} {day === 1 ? 'day' : 'days'}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                    </div>

                                    <div>
            <span className="text-muted small">
               <strong>Note:</strong> The start time fully matches the Amazon PDT launch time — you're all set.
            </span>
                                    </div>
                                </div>
                            </div>

                        </>
                    )}
                    {[10, 11, 12, 13, 14, 15, 16, 17,18,19,20,21,22,23,24,25,26,27].includes(Number(book.selectedAssType?.id)) && (
                        <Card className="mt-2 border border-secondary">
                            <Card.Body className="py-2">
                                {(() => {
                                    const price = Number(bookCostCompensation ?? 0);
                                    const hasPrice = Number.isFinite(price) && price > 0;

                                    const balance = Number(user?.user?.lr_balance ?? 0);
                                    const fmtUSD = (v) =>
                                        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
                                            .format(Number(v || 0));

                                    // Показываем кнопку, если баланс <= 0 ИЛИ если не хватает до цены книги
                                    const shouldShowAddBtn = balance <= 0 || (hasPrice && balance < price);

                                    return (
                                        <>
                                            {/* Ряд 1: слева компенсация (или ссылка на установку цены), справа короткая кнопка */}
                                            <div className="d-flex justify-content-between align-items-center mt-1 gap-2 flex-nowrap">

                                                {/* Левый блок */}
                                                <div
                                                    className="fw-semibold text-truncate"
                                                    title={hasPrice ? `Price Compensation: +${fmtUSD(price)}` : 'Set the book price'}
                                                >
                                                    {hasPrice ? (
                                                        <>
                                                            {/* Десктопная версия */}
                                                            <span className="d-none d-md-inline">
                                                              Book Cost Compensation:{' '}
                                                                <span className="text-success">{fmtUSD(price)}</span>
                                                             </span>

                                                            {/* Мобильная версия */}
                                                            <span className="d-inline d-md-none">
                                                             Cost:{' '}
                                                                <span className="text-success">{fmtUSD(price)}</span>
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0 text-danger text-decoration-underline fw-semibold"
                                                            onClick={goToEditBook}
                                                            aria-label="Set the book price (Edit Book)"
                                                            title="Set the book price (Edit Book)"
                                                        >
                                                            {/* Полная версия для десктопа */}
                                                            <span className="d-none d-md-inline">Set Book Price (No Moderation)</span>

                                                            {/* Короткая версия для мобильных */}
                                                            <span className="d-inline d-md-none">Set Price</span>
                                                        </button>

                                                    )}
                                                </div>

                                                {/* Правый блок */}
                                                <div className="d-flex align-items-center fw-semibold">
                                                    <>
                                                        {/* Полная версия для десктопа */}
                                                        <span className="d-none d-md-inline">Your USD Balance:{' '}</span>

                                                        {/* Короткая версия для мобильных */}
                                                        <span className="d-inline d-md-none">Balance:{' '}</span>
                                                    </>
                                                    <span className={balance <= 0 ? 'text-danger ms-1' : 'text-success ms-1'}>
      {fmtUSD(balance)}
    </span>
                                                    {shouldShowAddBtn && (
                                                        <Button
                                                            variant="success"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                typeof internalHandleClose === 'function' && internalHandleClose();
                                                                navigate(ADD_FUNDS_TO_USD_BALANCE_ROUTE);
                                                            }}
                                                            className="btn-sm ms-3"
                                                        >
                                                            Add Funds
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>


                                            {/* Ряд 3: статус ассигмента */}
                                            <div className="small text-muted mt-2 mb-1">
                                                This is a <span className="fw-semibold">new assignment type</span> now available on Virtalibry.
                                                You can already use it in full — set the book price, add funds to your USD balance, and publish.
                                                We’d really appreciate your <span className="fw-semibold">comments and feedback</span> on this flow.
                                            </div>

                                        </>
                                    );
                                })()}
                            </Card.Body>
                        </Card>




                    )}


                    {(Number(book.selectedAssType?.id) === 8 || Number(book.selectedAssType?.id) === 7) && (
                        <div className="d-flex flex-column gap-2 mt-2 mb-0" style={{ maxWidth: '800px' }}>
                            <h6 className="mb-0 text-muted" style={{ lineHeight: '0.5' }}>
                                Select Audible Country Site and Enter Promo Code:
                            </h6>

                            <div className="text-muted small mt-0">
                                Select the Audible site for which you are providing a promo code. This option is free for Premium users, costs +100V for Essential users, and +200V for Free users.
                            </div>

                            <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
                                <div className="flex-fill" style={{ maxWidth: "220px" }}>
                                    <label htmlFor="audibleSites" className="form-label small mb-1">
                                        Promo Code:
                                    </label>
                                    <input
                                        type="text"
                                        id="promoCode"
                                        className="form-control form-control-sm border-success mb-0"
                                        placeholder="Enter promo code here..."
                                        maxLength="40"
                                        value={promoCode}
                                        onChange={handlePromoCodeChange}
                                    />
                                </div>
                                <div className="flex-fill me-3" style={{ maxWidth: "370px" }}>
                                    <label htmlFor="audibleSites" className="form-label small mb-1">
                                        Audible Country Site:
                                    </label>
                                    <select
                                        id="audibleSites"
                                        name="audible_country"
                                        value={selectedCountry}
                                        className="form-select form-select-sm border-success mb-0"
                                        onChange={handleAudioSiteChange}
                                    >
                                        <option value="">Select Audible Country:</option>
                                        {audibleSites.map((site) => (
                                            <option key={site.code} value={site.url}>
                                                {site.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                            </div>
                        </div>
                    )}


                    {book.selectedAssType && (book.selectedAssType?.id === 4 || book.selectedAssType?.id === 6) && (
                        <>
                            <h6 className="mb-2 mt-3 text-muted">
                                For this type of assignment, you can upload your own photo. Please upload one:
                            </h6>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    {isLoading ? <Loader /> : <FileUpload onFileUpload={handleFileUpload} />}
                                </div>
                            </motion.div>
                        </>
                    )}
                    {selectedBookType && book.selectedAssType && (
                        <>
                            <div className="d-flex flex-column gap-2 mt-4 mb-0" style={{ maxWidth: '800px' }}>
                                <InfoTitle
                                    helpTitle="Speed-Up to Boost Competitiveness"
                                    helpContent={
                                        <>
                                            Readers pick higher-paying assignments first. Add a bonus to help yours stand out and get done faster.
                                            You can also apply visual effects, such as a pulsating animation or a bold color frame,
                                            to help your offer stand out even more.
                                        </>
                                    }
                                >
                                    Speed-Up to Boost Competitiveness:
                                </InfoTitle>


                                <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
                                    <select
                                        id="speedUp"
                                        name="speed_up"
                                        value={speedUp}
                                        className="form-select form-select-sm border-success mb-0"
                                        onChange={handleSpeedUpChange}
                                        style={{ maxWidth: '220px' }}
                                    >
                                        {!speedUpMassive.some((up) => Number(up.sum) === Number(speedUp)) && (
                                            <option value={speedUp} className="text-muted">
                                                +{speedUp} Virt Speed-Up
                                            </option>
                                        )}
                                        {speedUpMassive.map((up) => (
                                            <option key={up.id} value={up.sum} className=" text-muted">
                                                {up.label}
                                            </option>
                                        ))}
                                    </select>

                                    <select
                                        id="speedUpEffect"
                                        name="speed_up_effect"
                                        value={speedUpEffect.id}
                                        className="form-select form-select-sm border-success me-3 mb-0"
                                        onChange={handleSpeedUpEffectChange}
                                        style={{ maxWidth: '370px' }}
                                    >
                                        {speedUpEffectMassive.map((upe) => (
                                            <option key={upe.id} value={upe.id} className=" text-muted">
                                                {upe.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {speedUpEffect.id !== 0 && (
                                    <>
                                        {speedUpEffect.id === 1 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                <img
                                                    src="/img/site_img/gif_bold_gray_frame_demo.gif"
                                                    alt="Effect 2"
                                                    className="border border-secondary rounded"
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '500px'
                                                    }}
                                                />
                                                </div>
                                            </div>
                                        )}

                                        {speedUpEffect.id === 2 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                    <img
                                                        src="/img/site_img/gif_bold_green_frame_demo.gif"
                                                        alt="Effect 2"
                                                        className="border border-secondary rounded"
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '500px'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        )}

                                        {speedUpEffect.id === 3 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                    <img
                                                        src="/img/site_img/gif_bold_gold_frame_demo.gif"
                                                        alt="Effect 2"
                                                        className="border border-secondary rounded"
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '500px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {speedUpEffect.id === 4 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                    <img
                                                        src="/img/site_img/gif_pulsation_demo.gif"
                                                        alt="Effect 2"
                                                        className="border border-secondary rounded"
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '500px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {speedUpEffect.id === 5 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                    <img
                                                        src="/img/site_img/gif_pulsation_bold_gray_frame_demo.gif"
                                                        alt="Effect 2"
                                                        className="border border-secondary rounded"
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '500px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {speedUpEffect.id === 6 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                    <img
                                                        src="/img/site_img/gif_pulsation_bold_green_frame_demo.gif"
                                                        alt="Effect 2"
                                                        className="border border-secondary rounded"
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '500px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {speedUpEffect.id === 7 && (
                                            <div className="text-muted small">
                                                <div>You can see what this visual effect will look like in this example. This is just a demonstration of the visual effect.</div>
                                                <div className="text-center mt-2">
                                                    <img
                                                        src="/img/site_img/gif_pulsation_bold_gold_frame_demo.gif"
                                                        alt="Effect 2"
                                                        className="border border-secondary rounded"
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '500px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}


                                    </>
                                )}

                            </div>

                        </>
                    )}


                    {selectedBookType &&
                        selectedBookType.key !== 'audio_flag' &&
                        ![28, 29, 30, 31, 32].includes(book?.selectedAssType?.id) && (
                        <>


                            <div className="d-flex flex-column gap-2 mt-4 mb-0" style={{ maxWidth: '800px' }}>
                                <InfoTitle
                                    helpTitle="Targeting Options"
                                    helpContent={
                                        <>
                                            Limit visibility by Amazon marketplace and/or minimum reviewer quality.
                                            Leave unselected to allow all reviewers on all marketplaces.
                                            Marketplace targeting: Free for Premium users, +100V for Essential users, +200V for Free users.
                                            <br />
                                            <span className="fw-semibold">Reviewer quality filter: Free for now.</span> This filter shows your assignment only to reviewers whose quality
                                            score meets your threshold. <span className="fw-semibold">The score is calculated as:</span>
                                            <em> (Total completed reviews - Reviews with complaints) / Total completed reviews x 100%</em>
                                            <br />
                                            In other words, only reviewers with a complaint-free review ratio above your chosen percentage
                                            will see your assignment.
                                        </>
                                    }
                                >
                                    Targeting Options (optional)
                                </InfoTitle>

                                <div className="text-muted small mt-0 d-none">
                                    Limit visibility by Amazon marketplace and/or minimum reviewer quality.
                                    Leave unselected to allow all reviewers on all marketplaces.
                                    Marketplace targeting: Free for Premium users, +100V for Essential users, +200V for Free users. <br />
                                    <span className="fw-semibold">Reviewer quality filter: Free for now.</span> This filter shows your assignment only to reviewers whose quality
                                    score meets your threshold. <span className="fw-semibold">The score is calculated as:</span> <em> (Total completed reviews – Reviews with complaints) ÷ Total completed reviews × 100%
                                    </em> <br />
                                    In other words, only reviewers with a complaint-free review ratio above your chosen percentage
                                    will see your assignment.
                                </div>


                                <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mb-1">
                                <select
                                    id="amazonSites"
                                    name="amz_country"
                                    value={amzCountry.amz_country}
                                    className="form-select form-select-sm border-success mb-0"
                                    onChange={handleSiteChange}
                                    style={{ maxWidth: '220px' }}
                                >
                                    <option className=" text-muted" value="">Amazon Marketplace (Any):</option>
                                    {allowedAmazonSites.map((site) => (
                                        <option key={site.code} value={site.url} className="text-muted">
                                            {site.label}
                                        </option>
                                    ))}
                                </select>
                                    <select
                                        id="reviewQuality"
                                        name="review_quality"
                                        value={reviewQuality}
                                        className="form-select form-select-sm border-success mb-0 me-3"
                                        onChange={handleRQChange}
                                        style={{ maxWidth: '220px' }}
                                    >
                                        <option className=" text-muted" value="">Review Quality (Any):</option>
                                        {reviewQualityList.map((rq) => (
                                            <option key={rq.code} value={rq.value} className=" text-muted">
                                                {rq.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </>
                    )}

                    {/* 🔽 Поставь этот блок сразу под двумя селектами таргетинга */}
                    {(Boolean(amzCountry?.selected_site || amzCountry?.amz_country) || Number(reviewQuality) > 0) && (
                        (() => {
                            const filteredPool = targetingForecast?.stats?.filteredPool;
                            const isCriticalLowPool = typeof filteredPool === 'number' && filteredPool < 10;

                            return (
                                <Card
                                    className={`mt-3 border ${isCriticalLowPool ? 'border-danger' : 'border-secondary'} me-4 ms-4`}
                                >
                                    <Card.Header
                                        className={`py-1 text-white fw-semibold ${
                                            isCriticalLowPool ? 'bg-danger' : 'bg-secondary bg-card-header'
                                        }`}
                                    >
                                        {isCriticalLowPool ? (
                                            <>Very small reviewer pool detected. We recommend choosing a different marketplace.</>
                                        ) : (
                                            <>
                                                By applying these filters, you reduce the number of potential reviewers roughly{' '}
                                                {Number(targetingForecast?.stats?.ratio).toFixed(1)}-fold.
                                            </>
                                        )}
                                    </Card.Header>

                                    <Card.Body className="py-2">
                                        {isForecastLoading && (
                                            <div className="small text-muted d-flex align-items-center">
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Calculating forecast…
                                            </div>
                                        )}

                                        {!isForecastLoading && forecastError && (
                                            <div className="small text-danger">{forecastError}</div>
                                        )}

                                        {!isForecastLoading && !forecastError && targetingForecast && (
                                            <>
                                                {!isCriticalLowPool ? (
                                                    <div className="small text-muted">
                                                        {targetingForecast.message}
                                                    </div>
                                                ) : (
                                                    <div className="small text-danger">
                                                        <p className="mb-1">
                                                            Sorry — applying this filter for the selected marketplace is
                                                            <strong> strongly not recommended</strong> due to the extremely small
                                                            number of available respondents.
                                                        </p>

                                                        <p className="mb-1">
                                                            We believe that the user base will grow in the near future and this
                                                            warning will disappear. However, at the moment you may place this
                                                            assignment <strong>only at your own discretion</strong>.
                                                        </p>

                                                        <p className="mb-0">
                                                            Reviewer search may take a <strong>very long time</strong>.
                                                            We strongly suggest trying a different marketplace.
                                                        </p>
                                                    </div>

                                                )}

                                                {/* Техническая строка — можно оставить закомментированной
                            {targetingForecast.stats && (
                                <div className="small text-muted mt-1">
                                    Pool: <strong>{targetingForecast.stats.filteredPool ?? 0}</strong> / {targetingForecast.stats.basePool ?? 0}
                                    {typeof targetingForecast.stats.ratio === 'number' && (
                                        <span className="ms-2">(~{Number(targetingForecast.stats.ratio).toFixed(1)}×)</span>
                                    )}
                                </div>
                            )}
                            */}
                                            </>
                                        )}

                                        {!isForecastLoading && !forecastError && !targetingForecast && (
                                            <div className="small text-muted">Forecast will appear here.</div>
                                        )}
                                    </Card.Body>
                                </Card>
                            );
                        })()
                    )}



                </div>

                {user?.user?.level_of_trust < 399 && (Number(book.selectedAssType?.id) === 4 ||
                    (Number(book?.selectedAssType?.id) === 5 || Number(book?.selectedAssType?.id) === 6)) && (


                    <div
                        className="alert alert-danger p-3 mb-2 small"
                        style={{
                            maxWidth: '600px',
                            margin: '0 auto',
                            lineHeight: '1.25'
                        }}
                    >
                        <h6 className="mb-2 fw-bold text-center text-danger">
                            ATTENTION!
                        </h6>

                        <p className="mb-1 text-muted">
                            Your current Trust Score is <strong>{user?.user?.level_of_trust}</strong>.
                            To post this type of assignment, you need a Trust Score higher than <strong>400</strong>.
                        </p>

                        <p className="mb-1 text-muted">
                            The "Post Assignment" button is currently <strong>disabled</strong>.
                        </p>

                        <p className="mb-1 text-muted">
                            To increase your Trust Score and unlock this type of assignment, you can:
                        </p>

                        <ul className="mb-1 text-muted ps-3" style={{ marginBottom: '0.25rem' }}>
                            <li>Stay active on your current plan by completing review-writing assignments.</li>
                            <li>Post simpler assignments for your books.</li>
                            <li>Upgrade to a higher plan to instantly receive additional Trust Score points.</li>
                        </ul>
                    </div>

                )}

</>}
                <div className="mt-2 mb-2 px-3 d-flex flex-column flex-lg-row align-items-start gap-3">
                <div
                    className="d-flex flex-column gap-1 small text-muted flex-shrink-0"
                    style={{
                        width: '280px',
                        maxWidth: '100%',
                        lineHeight: '1.2'
                    }}
                >
                    <div>Base Cost: {basePrice} Virt.</div>
                    <div>Faster Days: +{currency} Virt.</div>
                    <div>Speed Up & Visual: +{Number(speedUp)+Number(speedUpEffect.sum) || 0} Virt.</div>
                    <div>Assignment Type: +{assTypeAddition} Virt.</div>
                    <div>Price Type: +{priceAddition} Virt.</div>
                    <div>Site Filter: +{siteAddition} Virt.</div>
                    <div>
                        {Number(bookCostCompensation) > 0 && (
                            <>Cost Compensation: <strong className="text-success">
                                {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
                                    .format(Number(bookCostCompensation))}
                            </strong></>
                        )}
                    </div>

                    {totalDiscount > 0 && <div>Subtotal: {totalCost} Virt.</div>}
                    {bookTypeDiscount > 0 && <div className="text-danger fw-bolder">Book Placement Discount: −{bookTypeDiscount} Virt.</div>}
                    {assTypeDiscount > 0 && <div className="text-danger fw-bolder">Assignment Placement Discount: -{assTypeDiscount} Virt.</div>}
                    {priceTypeDiscount > 0 && <div className="text-danger fw-bolder">Price Placement Discount: −{priceTypeDiscount} Virt.</div>}

                    <div className="fw-bolder">
                        Total: {Number(totalCost || 0) - Number(totalDiscount || 0)} Virt
                        {Number(bookCostCompensation) > 0 && (
                            <> {' '}+ {
                                new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
                                    .format(Number(bookCostCompensation))
                            }</>
                        )}
                    </div>

                </div>
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <AssignmentPriceAdvisor
                        visible={Boolean(book.selectedAssType && totalCost > 0)}
                        assignmentName={book.selectedAssType?.ass_type_name}
                        currentPriceVirt={
                            Number.isFinite(Number(totalCost)) && totalCost > 0
                                ? Math.round(totalCost)
                                : null
                        }
                        stats={priceStats}
                        isLoading={isPriceStatsLoading}
                        error={priceStatsError}
                        speedUpOptions={speedUpMassive}
                        currentSpeedUp={Number(speedUp) || 0}
                        onSpeedUpChange={setSpeedUp}
                    />
                </div>
                </div>
                <div
                    className="modal-footer small d-flex align-items-center justify-content-end gap-2 px-2"
                    style={{ height: 50, paddingTop: 0, paddingBottom: 0 }}
                >
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                            setError('');
                            internalHandleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    {(() => {
                        const trustBlocked =
                            user?.user?.level_of_trust < 399 &&
                            [4, 5, 6].includes(Number(book?.selectedAssType?.id));

                        const progressBlocked =
                            loading ||
                            !hasCompletedLibraryOffer;

                        // Блокируем, если есть признак компенсации (тип в разработке)
                        const comingSoonBlocked = bookCostCompensation === null; // именно "не null"

                        const disabled = trustBlocked || progressBlocked;

                        return (
                            <button
                                type="button"
                                className="btn btn-sm btn-success"
                                disabled={disabled}
                                onClick={addAssign}

                            >
                                {comingSoonBlocked
                                    ? 'Post this Assignment'
                                    : (loading ? <Spinner as="span" animation="border" size="sm" /> : 'Post this Assignment')}
                            </button>
                        );
                    })()}
                </div>

            </div>

        </Modal>
        </>
    );
});

export default CreateAssign;
